import { jsx as e, jsxs as u, Fragment as R } from "react/jsx-runtime";
import { withManagedProps as f } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as P } from "@made-people/react-prop-guard";
import pe, { useEffect as x, useState as G, isValidElement as At, useRef as Se, useCallback as we, useMemo as Dt } from "react";
import { p as It, a as zt, b as j, c as Lt, s as xt, d as Gt, e as Wt, f as Ot, g as Rt, h as jt, i as Kt, j as Mt, k as Ht, l as Et, m as Vt, n as Ut, o as $t, q as Ft, r as Qt, t as qt, u as Zt, v as me, w as Yt, x as Jt, y as Xt, z as ea, A as ta, B as aa, C as ia, D as na, E as oa, F as sa, G as ra, H as la, I as ca, J as ne } from "./blueprint-572e03d6.mjs";
import { Drawer as D } from "@made-people/blueprint-drawer";
import * as J from "@radix-ui/react-dialog";
import { useOverlayState as da, overlayEventEmitter as X } from "@made-people/blueprint-overlay";
import { useProductBase as C, ProductLink as re, useProductAttributeGetter as $, useProductPriceInfo as le, useProductDataModel as W, useBundlePurchaseInfo as he, useProductImages as ua, useMediaAttributeGetter as _e, useRelatedProducts as be, ProductProvider as Ne, filterMediaOnAttributeValues as We, useProductSpecificationGroup as pa, useProductAttribute as z, useProductPurchaseStatus as ge, useProductOptions as Te, useProductSiblings as Oe, useBundleOptions as Be, useBundleItemId as ma, useBundlePurchaseStatus as ha, useProductHasOptionsInStock as ba } from "@made-people/grease-product";
import { useTranslate as _ } from "@made-people/grease-translations";
import ga from "clsx";
import { accordionItemSchema as fa, accordionSchema as Pa, Accordion as va } from "@made-people/blueprint-accordion";
import { useKeenSlider as Ge } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ResponsiveImage as F, responsiveImageSchema as Re } from "@made-people/blueprint-responsive-image";
import { useBreakpointVisibility as ya } from "@made-people/blueprint-ui-hooks";
import { responsiveVideoSchema as Sa, ResponsiveVideo as je } from "@made-people/blueprint-responsive-video";
import { MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY as Ke } from "@made-people/blueprint-mix-and-match";
import { badgeSchema as Me, Badge as Ce } from "@made-people/blueprint-badge";
import { CartEventAdditionalDataProvider as wa, useUpdateCart as fe, useCartMethod as ka } from "@made-people/grease-cart";
import { uiEventEmitter as _a } from "@made-people/grease-ui-events";
import { Heading as Na } from "@made-people/blueprint-heading";
import { isNotUndefined as Ta } from "@made-people/typeguards-common";
import { motion as U, AnimatePresence as ee, cubicBezier as He } from "motion/react";
import { linkAsLinkSchema as Ba, Link as Ca, LinkAsLink as Aa, linkAsButtonSchema as Da, LinkAsButton as Ia } from "@made-people/blueprint-link";
import { buttonContentPropsSchema as te, ButtonAsButton as oe, Button as q, buttonAsButtonSchema as ke, ButtonAsSpan as Ee, buttonAsSpanSchema as za } from "@made-people/blueprint-button";
import { toast as La } from "sonner";
import { productCardSchema as xa, ProductCard as Ga } from "@made-people/blueprint-product-card";
import { SearchResultProvider as Ve, useSearchResultItems as Wa } from "@made-people/grease-search";
import { swipeableProductListSchema as Ue, SwipeableProductList as Oa } from "@made-people/blueprint-swipeable-product-list";
import { Markdown as Ra } from "@made-people/blueprint-markdown";
import { GridContext as ja } from "@made-people/blueprint-grid";
import { Breadcrumbs as Z, breadcrumbsSchema as Ka } from "@made-people/blueprint-breadcrumbs";
import { shippingBarometerSchema as Ma, ShippingBarometer as Ha } from "@made-people/blueprint-shipping-barometer";
import { NotifyMe as $e } from "@made-people/blueprint-notify-me";
import { StatusInformationIcon as Ea } from "@made-people/blueprint-icons";
import { useLink as Va } from "@made-people/grease-link";
import "@made-people/blueprint";
const Ua = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12.9 12.9",
    children: /* @__PURE__ */ e("path", { d: "M7.5,6.5L12.7,1.3c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-5.2,5.2L1.3.2C1,0,.5,0,.2.2s-.2.3-.2.5,0,.4.2.5l5.2,5.2L.2,11.6c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l5.2-5.2,5.2,5.2c.1.1.3.2.5.2s.4,0,.5-.2.2-.3.2-.5,0-.4-.2-.5l-5.2-5.2Z" })
  }
), $a = ({
  children: a,
  CloseIcon: n,
  slots: i
}) => {
  const { isOpen: o, onChange: s } = da();
  return x(() => {
    s(!0);
  }, []), /* @__PURE__ */ e(J.Root, { defaultOpen: !0, onOpenChange: s, open: o, children: /* @__PURE__ */ u(J.Portal, { children: [
    /* @__PURE__ */ e(J.Overlay, { className: i.modalOverlay }),
    /* @__PURE__ */ u(
      J.Content,
      {
        "aria-description": "Product Page Modal",
        "aria-describedby": "Product",
        className: i.modalContent,
        children: [
          /* @__PURE__ */ e(J.Title, { hidden: !0, children: "Product Page" }),
          /* @__PURE__ */ e(J.Close, { className: i.closeButton, children: n }),
          /* @__PURE__ */ e("section", { className: i.contentWrapper, children: a })
        ]
      }
    )
  ] }) });
}, Fe = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional()
}), Fa = f(
  "ProductDrawer",
  P(
    Fe,
    ({ variants: a, children: n, closeIcon: i = Ua, drawerSettings: o }) => {
      const s = It.styles(a), [c, r] = G(!1);
      x(() => {
        r(window.innerWidth > 1124);
      }, []);
      const l = () => typeof i == "string" || At(i) ? i : typeof i == "function" ? /* @__PURE__ */ e(i, {}) : null;
      return c ? /* @__PURE__ */ e($a, { CloseIcon: l(), slots: s, children: n }) : /* @__PURE__ */ e(
        D,
        {
          ...o,
          defaultOpen: !0,
          direction: "bottom",
          variants: {
            dimmed: "subtle",
            blurred: "subtle",
            background: "none",
            ...o == null ? void 0 : o.variants
          },
          children: /* @__PURE__ */ u(
            D.Content,
            {
              contentSettings: {
                "aria-description": "Content for product popup",
                "aria-describedby": "Product"
              },
              children: [
                /* @__PURE__ */ e(D.Close, { className: s.closeButton, children: l() }),
                /* @__PURE__ */ e(D.Title, { hidden: !0, children: "Product Page popup" }),
                /* @__PURE__ */ e("div", { className: s.drawerWrapper, children: /* @__PURE__ */ e("section", { className: s.contentWrapper, children: n }) })
              ]
            }
          )
        }
      );
    }
  )
), Qe = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional()
}), Qa = f(
  "ProductGrid",
  P(Qe, ({ variants: a, children: n }) => {
    const i = zt.styles(a);
    return /* @__PURE__ */ e("section", { className: i.base, children: n });
  })
), qa = t.discriminatedUnion("template", [
  Fe,
  Qe
]), Za = f(
  "ProductRoot",
  P(qa, (a) => a.template === "drawer" ? /* @__PURE__ */ e(Fa, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Qa, { ...a }) : null)
), qe = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  blueprint: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  asLink: t.boolean().optional()
}), Ya = f(
  "ProductDetailsName",
  P(
    {
      schema: qe,
      defaultProps: {
        headingTag: "h1"
      }
    },
    ({ variants: a, text: n, headingTag: i, asLink: o, ...s }) => {
      const c = C(), {
        content: { name: r }
      } = c, d = (s.blueprint ?? j.main).styles(a), m = i ?? "h1", g = n ?? r;
      return o ? /* @__PURE__ */ e(m, { className: d.name, children: /* @__PURE__ */ e(re, { productBase: c, context: "product-card", children: g }) }) : /* @__PURE__ */ e(m, { className: d.name, children: g });
    }
  )
), Ja = t.object({
  variants: t.custom().optional()
}), Xa = f(
  "ProductDetailsShortDescription",
  P(Ja, ({ variants: a }) => {
    const {
      content: { shortDescription: n }
    } = C(), i = j.main.styles(a);
    return n ? /* @__PURE__ */ e("p", { className: i.shortDescription, children: n }) : null;
  })
), Ae = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  readMoreSettings: t.object({
    enabled: t.boolean(),
    limit: t.number().optional()
  }).optional(),
  label: t.string().optional(),
  blueprint: t.custom().optional(),
  formatDotsToList: t.boolean().optional()
}), ei = f(
  "ProductDetailsDescription",
  P(
    Ae,
    ({
      variants: a,
      readMoreSettings: n,
      text: i,
      label: o,
      formatDotsToList: s,
      ...c
    }) => {
      const {
        content: { description: r }
      } = C(), d = (c.blueprint ?? j.main).styles(a), [m, g] = G(!(n != null && n.enabled)), v = _();
      if (!r && !i)
        return null;
      const b = i ?? r, h = b.length > ((n == null ? void 0 : n.limit) ?? 200), y = s ? b.split(`
`).map((w) => {
        const S = w.trim();
        return S.startsWith("•") ? `<li>${S.substring(1).trim()}</li>` : S ? `${S}` : "";
      }).join("") : b;
      return /* @__PURE__ */ u("div", { className: d.description, children: [
        o && /* @__PURE__ */ e("h2", { className: d.descriptionLabel, children: o }),
        /* @__PURE__ */ e(
          "p",
          {
            className: m ? "" : "line-clamp-2",
            dangerouslySetInnerHTML: {
              __html: m ? y : `${y.substring(0, 200)}...`
            }
          }
        ),
        (n == null ? void 0 : n.enabled) && h && /* @__PURE__ */ e(
          "button",
          {
            className: d.descriptionReadMoreButton,
            onClick: () => g(!m),
            children: v(m ? "Product_Description_Read_Less" : "Product_Description_Read_More")
          }
        )
      ] });
    }
  )
), ti = t.object({
  variants: t.custom().optional()
}), ai = f(
  "ProductDetailsBrand",
  P(ti, ({ variants: a }) => {
    var c;
    const n = C(), i = j.main.styles(a), s = (c = $(n)("brandName", t.string())) == null ? void 0 : c.value;
    return s ? /* @__PURE__ */ e("span", { className: i.brand, children: s }) : null;
  })
), Ze = t.object({
  drawerSettings: t.custom().optional(),
  trigger: t.custom().optional(),
  isEnabled: t.boolean().optional()
}), ii = 1024, ni = f(
  "PriceHistoryDrawer",
  P(Ze, (a) => {
    var m, g;
    const n = Lt.styles(), i = le(), [o, s] = G(!1), c = _(), r = (m = i.previouslyDiscountedPrices) == null ? void 0 : m.find(
      (v) => v.periodDays === 30
    ), l = i.price.formatted !== (r == null ? void 0 : r.price.formatted);
    if (x(() => {
      const v = () => {
        s(window.innerWidth > ii);
      };
      return window.addEventListener("resize", v), v(), () => {
        window.removeEventListener("resize", v);
      };
    }, []), !a.isEnabled)
      return null;
    const d = (g = i.discountInfo) != null && g.percent ? `(-${i.discountInfo.percent}%)` : "";
    return /* @__PURE__ */ u(
      D,
      {
        customOverlayId: "price-history",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        header: {
          headingSettings: {
            heading: c("Price_History_Heading")
          }
        },
        hasHandle: !o,
        variants: {
          dragHandle: o ? "false" : "true",
          rounded: o ? "none" : "strong",
          background: "white",
          direction: o ? "right" : "bottom"
        },
        direction: o ? "right" : "bottom",
        ...a.drawerSettings,
        children: [
          l && /* @__PURE__ */ u(D.Trigger, { className: n.trigger, children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "absolute w-10 h-10",
                tabIndex: -1,
                "aria-hidden": "true"
              }
            ),
            a.trigger
          ] }),
          /* @__PURE__ */ e(D.Content, { children: /* @__PURE__ */ u("div", { className: n.contentWrapper, children: [
            /* @__PURE__ */ u("div", { className: n.priceRow, children: [
              /* @__PURE__ */ e("span", { className: n.priceValue, children: i.price.formatted }),
              d && /* @__PURE__ */ e("span", { className: n.discountBadge, children: c("Price_History_Current_Price", {
                discountPercent: d
              }) })
            ] }),
            r && /* @__PURE__ */ u("div", { className: n.priceRow, children: [
              /* @__PURE__ */ e("span", { className: n.priceValue, children: r.price.formatted }),
              /* @__PURE__ */ e("span", { className: n.priceLabel, children: c("Price_History_Lowest_Price_In_Last_30_Days") })
            ] }),
            /* @__PURE__ */ u("div", { className: n.priceRow, children: [
              /* @__PURE__ */ e("span", { className: n.priceValue, children: i.priceWithoutDiscount.formatted }),
              /* @__PURE__ */ e("span", { className: n.priceLabel, children: c("Price_History_Original_Price") })
            ] })
          ] }) })
        ]
      }
    );
  })
), Ye = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  priceHistoryDrawerSettings: Ze.optional()
}), oi = f(
  "ProductDetailsPrice",
  P(Ye, ({ variants: a, ...n }) => {
    const i = le(), s = (n.blueprint ?? j.main).styles(a), c = W(), r = i.price.number < i.priceWithoutDiscount.number;
    return /* @__PURE__ */ e(R, { children: /* @__PURE__ */ u("div", { className: s.priceWrapper, children: [
      /* @__PURE__ */ e(
        "span",
        {
          "data-is-discounted": r ? "true" : "false",
          className: s.price,
          children: i.price.formatted
        }
      ),
      r && /* @__PURE__ */ u("span", { className: s.oldPrice, children: [
        i.priceWithoutDiscount.formatted,
        /* @__PURE__ */ e(
          p.PriceHistoryDrawer,
          {
            ...n.priceHistoryDrawerSettings
          }
        )
      ] }),
      c === "bundle" && /* @__PURE__ */ e(si, {})
    ] }) });
  })
), si = () => (he(), null), ri = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional()
}), li = f(
  "ProductDetailsWrapper",
  P(ri, ({ variants: a, children: n }) => {
    const i = j.main.styles(a);
    return /* @__PURE__ */ e("section", { className: i.wrapper, children: n });
  })
), ae = t.object({
  variants: t.custom().optional(),
  attributeKey: t.string().optional(),
  className: t.string().optional(),
  label: t.string().optional()
}), ci = f(
  "ProductDetailsProductType",
  P(
    {
      schema: ae,
      defaultProps: {
        attributeKey: "subHeadline"
      }
    },
    ({ variants: a, attributeKey: n, className: i, label: o }) => {
      var d;
      const s = C(), r = (d = $(s)(
        n ?? "",
        t.string()
      )) == null ? void 0 : d.value, l = j.main.styles(a);
      if (!(!r && !o))
        return /* @__PURE__ */ e("span", { className: ga(l.productType, i), children: o ?? r });
    }
  )
), Je = fa.extend({
  content: t.object({
    value: t.string().optional(),
    attributeKey: t.string().optional(),
    trigger: t.custom().optional(),
    content: t.custom().optional(),
    forceMount: t.boolean().optional()
  })
}), di = t.object({
  variants: t.custom().optional(),
  items: t.array(Je).optional(),
  settings: Pa.omit({ items: !0 }).optional()
}), ui = f(
  "ProductDetailsAccordion",
  P(di, ({ variants: a, items: n, settings: i }) => {
    const o = C(), s = $(o), c = j.main.styles(a), r = n == null ? void 0 : n.map((l) => {
      var m;
      let d = l.content.content;
      if (l.content.attributeKey) {
        const g = (m = s(
          l.content.attributeKey,
          t.string()
        )) == null ? void 0 : m.value;
        if (!d && !g)
          return null;
        d = g ?? d;
      }
      return d ? {
        ...l,
        content: {
          content: d,
          value: l.content.value,
          trigger: l.content.trigger,
          forceMount: l.content.forceMount
        }
      } : null;
    }).filter((l) => l !== null);
    return r ? /* @__PURE__ */ e("div", { className: c.accordionWrapper, children: /* @__PURE__ */ e(
      va,
      {
        ...i,
        blueprint: j.accordion,
        layout: {
          spacing: {
            applySpacing: "false"
          },
          position: {
            applyPosition: "false"
          }
        },
        items: r
      }
    ) }) : null;
  })
), pi = {
  Name: Ya,
  ShortDescription: Xa,
  Brand: ai,
  Price: oi,
  Wrapper: li,
  Description: ei,
  ProductType: ci,
  Accordion: ui
  // Add other components as needed
}, mi = t.object({
  className: t.string().optional(),
  badgeSettings: Me.optional(),
  hide: t.boolean().optional()
}), hi = ({
  badgeSettings: a,
  hide: n,
  className: i
}) => {
  const o = _(), s = he(), c = s.discountFromPriceOfItemsOutsideBundle.formatted, r = s.discountFromPriceOfItemsOutsideBundle.number;
  return n || !c || r <= 0 ? null : /* @__PURE__ */ e("div", { className: i, children: /* @__PURE__ */ e(
    Ce,
    {
      ...a,
      label: o("PDP_Bundle_Savings_Badge", { bundleSavings: c })
    }
  ) });
}, Xe = f(
  "BundleSavingsBadge",
  P(mi, (a) => W() !== "bundle" ? null : /* @__PURE__ */ e(hi, { ...a }))
), bi = t.object({
  subHeadlineAttribute: t.string().optional(),
  variants: t.custom().optional()
}), gi = f(
  "ShopTheLookItem",
  P(
    {
      schema: bi,
      defaultProps: {
        subHeadlineAttribute: "subHeadline"
      }
    },
    ({ subHeadlineAttribute: a, variants: n }) => {
      var v;
      const i = C(), o = ua(), s = le(), c = W(), r = $(i), l = xt.styles(n), d = o == null ? void 0 : o[0], m = s.price.number < s.priceWithoutDiscount.number, g = a ? (v = r(a, t.string())) == null ? void 0 : v.value : void 0;
      return /* @__PURE__ */ u("div", { className: l.wrapper, children: [
        /* @__PURE__ */ u("div", { className: l.contentWrapper, children: [
          d && /* @__PURE__ */ e(
            re,
            {
              productBase: i,
              context: "product-card",
              className: l.imageWrapper,
              children: /* @__PURE__ */ e(F, { className: l.image, image: d })
            }
          ),
          /* @__PURE__ */ u("div", { className: l.info, children: [
            /* @__PURE__ */ e("h4", { className: l.productName, children: i.content.name }),
            g && /* @__PURE__ */ e("p", { className: l.productType, children: g }),
            /* @__PURE__ */ u("div", { className: l.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": m ? "true" : "false",
                  className: l.price,
                  children: s.price.formatted
                }
              ),
              m && /* @__PURE__ */ e("span", { className: l.priceBeforeDiscount, children: s.priceWithoutDiscount.formatted })
            ] })
          ] })
        ] }),
        c === "with_variants" && /* @__PURE__ */ e(p.SizePicker, { template: "button-grid" }),
        /* @__PURE__ */ e(
          p.AddToCart,
          {
            template: "button",
            postAddAction: "none",
            buttonSettings: {
              variants: {
                width: "full"
              }
            }
          }
        )
      ] });
    }
  )
), De = "shop_the_look", fi = t.object({
  media: t.custom().optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.custom().optional(),
  triggerIcon: t.custom().optional(),
  showProductCountAsSuffix: t.boolean().optional()
}), Pi = () => {
  const [a, n] = G(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return x(() => {
    const i = () => {
      n(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, []), a;
}, et = f(
  "ShopTheLook",
  P(
    {
      schema: fi,
      defaultProps: {}
    },
    ({
      media: a,
      className: n = "",
      variants: i,
      drawerSettings: o,
      closeIcon: s,
      triggerIcon: c,
      showProductCountAsSuffix: r
    }) => {
      const [l, d] = G(!1), m = Pi(), g = _e(
        a || {
          type: "image",
          src: "",
          alt: ""
        }
      ), v = (a == null ? void 0 : a.type) === "image" && g(De, t.boolean()), b = Gt.styles(i), h = be("look"), y = _();
      if (!v || v.value !== !0 || !h.length)
        return null;
      const w = () => {
        _a.emit("featureInteraction", {
          feature: "shop_the_look",
          action: "clicked"
        });
      };
      return /* @__PURE__ */ u(
        D,
        {
          open: l,
          onOpenChange: d,
          direction: m ? "right" : "bottom",
          variants: {
            rounded: "subtle"
          },
          ...o,
          children: [
            /* @__PURE__ */ e(
              D.Trigger,
              {
                className: n || b.trigger,
                onClick: w,
                "aria-label": `Shop The Look - ${h.length} ${h.length === 1 ? "product" : "products"}`,
                children: /* @__PURE__ */ u("div", { className: b.triggerContent, children: [
                  y("Shop_The_Look_Trigger"),
                  c
                ] })
              }
            ),
            /* @__PURE__ */ u(D.Content, { children: [
              /* @__PURE__ */ e(D.Title, { hidden: !0, children: y("Shop_The_Look_Heading") }),
              /* @__PURE__ */ u("div", { className: b.wrapper, children: [
                /* @__PURE__ */ u("div", { className: b.header, children: [
                  /* @__PURE__ */ e(
                    Na,
                    {
                      heading: y("Shop_The_Look_Heading"),
                      suffix: r ? String(h.length) : void 0,
                      variants: { headingSize: "lg" }
                    }
                  ),
                  /* @__PURE__ */ e(D.Close, { className: b.close, children: s ?? y("Shop_The_Look_Close") })
                ] }),
                /* @__PURE__ */ e("div", { className: b.productList, children: h.map((S, B) => /* @__PURE__ */ e(
                  wa,
                  {
                    additionalData: {
                      source: "shop-the-look",
                      item_list_id: "shop-the-look",
                      item_list_name: "Shop The Look"
                    },
                    children: /* @__PURE__ */ e(
                      Ne,
                      {
                        product: S.product,
                        context: {
                          type: "plp",
                          listId: "shop-the-look",
                          listName: "Shop The Look",
                          position: B
                        },
                        children: /* @__PURE__ */ e(gi, {})
                      }
                    )
                  },
                  S.product.base.productId
                )) })
              ] })
            ] })
          ]
        }
      );
    }
  )
), Pe = t.object({
  template: t.literal("keen"),
  variants: t.custom().optional(),
  indicator: t.literal("number").or(t.literal("dots")).optional(),
  navigation: t.object({
    enabled: t.object({
      mobile: t.boolean().optional().default(!1),
      tablet: t.boolean().optional().default(!1),
      desktop: t.boolean().optional().default(!1)
    }),
    prevIcon: t.custom().optional(),
    nextIcon: t.custom().optional()
  }).optional(),
  slidesPerView: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  gap: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  children: t.custom().optional(),
  buttonInSlider: t.object({
    enabled: t.boolean().optional(),
    onClick: t.custom().optional(),
    label: t.string().optional()
  }).optional(),
  blueprint: t.custom().optional(),
  videoSettings: Sa.optional(),
  customComponent: t.custom().optional()
}), vi = f(
  "ImageGalleryAsKeen",
  P(
    Pe,
    ({
      variants: a,
      indicator: n,
      navigation: i,
      slidesPerView: o,
      gap: s,
      children: c,
      buttonInSlider: r,
      videoSettings: l,
      customComponent: d,
      ...m
    }) => {
      var Q, M, H;
      const {
        content: { media: g }
      } = C(), b = (m.blueprint ?? Wt).styles(a), [h, y] = pe.useState(0);
      function w(k) {
        return (N) => {
          function E() {
            N.slides.forEach((V) => {
              V.classList.remove("active");
            });
          }
          function xe(V) {
            N.slides[V].classList.add("active");
          }
          function Ct() {
            N.slides.forEach((V, ue) => {
              V.addEventListener("click", () => {
                k.current && k.current.moveToIdx(ue);
              });
            });
          }
          N.on("created", () => {
            k.current && (xe(N.track.details.rel), Ct(), k.current.on("animationStarted", (V) => {
              E();
              const ue = V.animator.targetIdx || 0;
              xe(V.track.absToRel(ue)), N.moveToIdx(Math.min(N.track.details.maxIdx, ue));
            }));
          });
        };
      }
      const S = We(g, {
        key: Ke,
        value: [!1, void 0]
      }), A = (S == null ? void 0 : S.length) === 1, I = pe.useMemo(
        () => S.map((k) => k.src).join(","),
        [S]
      ), [T, L] = Ge({
        selector: ".keen-slider__slide",
        mode: "snap",
        loop: !A,
        breakpoints: {
          "(min-width: 0px)": {
            slides: {
              perView: A ? 1 : (o == null ? void 0 : o.mobile) ?? 1,
              spacing: (s == null ? void 0 : s.mobile) ?? 12
            }
          },
          "(min-width: 640px)": {
            slides: {
              perView: A ? 1 : (o == null ? void 0 : o.tablet) ?? 1,
              spacing: (s == null ? void 0 : s.tablet) ?? 24
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: A ? 1 : (o == null ? void 0 : o.desktop) ?? 1,
              spacing: (s == null ? void 0 : s.desktop) ?? 20
            }
          }
        },
        slideChanged(k) {
          y(k.track.details.rel);
        }
      });
      pe.useEffect(() => {
        y(0);
      }, [I]);
      const [K] = Ge(
        {
          initial: 0,
          slides: {
            perView: "auto",
            spacing: 4
          }
        },
        [w(L)]
      ), O = ya({
        mobile: (Q = i == null ? void 0 : i.enabled) == null ? void 0 : Q.mobile,
        tablet: (M = i == null ? void 0 : i.enabled) == null ? void 0 : M.tablet,
        desktop: (H = i == null ? void 0 : i.enabled) == null ? void 0 : H.desktop
      });
      return /* @__PURE__ */ u(
        "div",
        {
          className: b.base,
          "data-button-in-slider": (r == null ? void 0 : r.enabled) ?? !1,
          children: [
            /* @__PURE__ */ e(Xe, { className: b.bundleSavingsBadge }),
            /* @__PURE__ */ u(
              "div",
              {
                ref: T,
                className: `keen-slider ${b.galleryWrapper}`,
                children: [
                  c,
                  S.map((k, N) => k ? /* @__PURE__ */ e(
                    yi,
                    {
                      media: k,
                      position: N,
                      index: N,
                      slots: b,
                      currentSlide: h,
                      videoSettings: l
                    },
                    `${k.src}-${N}`
                  ) : null),
                  d && d,
                  (r == null ? void 0 : r.enabled) && (r == null ? void 0 : r.onClick) && (r == null ? void 0 : r.label) && /* @__PURE__ */ e(
                    "button",
                    {
                      className: b.linkButton,
                      onClick: r.onClick,
                      children: r.label
                    }
                  ),
                  n === "number" && /* @__PURE__ */ u("span", { className: b.numberIndicator, children: [
                    "[ ",
                    h + 1,
                    " / ",
                    S.length,
                    " ]"
                  ] }),
                  n === "dots" && /* @__PURE__ */ e("span", { className: b.dotsIndicatorWrapper, children: S.map((k, N) => /* @__PURE__ */ e(
                    "button",
                    {
                      "data-is-active": h === N ? "true" : "false",
                      onClick: () => {
                        var E;
                        return (E = L.current) == null ? void 0 : E.moveToIdx(N);
                      },
                      className: b.dotsIndicator
                    },
                    N
                  )) }),
                  !A && (i == null ? void 0 : i.prevIcon) && (i == null ? void 0 : i.nextIcon) && /* @__PURE__ */ u("div", { className: b.arrowsWrapper, ...O, children: [
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.leftArrow,
                        onClick: () => {
                          var k;
                          return (k = L.current) == null ? void 0 : k.prev();
                        },
                        children: i == null ? void 0 : i.prevIcon
                      }
                    ),
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.rightArrow,
                        onClick: () => {
                          var k;
                          return (k = L.current) == null ? void 0 : k.next();
                        },
                        children: i == null ? void 0 : i.nextIcon
                      }
                    )
                  ] })
                ]
              },
              I
            ),
            S.length > 1 && /* @__PURE__ */ e(
              "div",
              {
                ref: K,
                className: `keen-slider thumbnail ${b.thumbnailWrapper}`,
                children: S.map((k, N) => /* @__PURE__ */ e(
                  "div",
                  {
                    "data-is-active": h === N ? "true" : "false",
                    className: `keen-slider__slide relative ${b.thumbnail}`,
                    children: k.type === "image" && /* @__PURE__ */ e(
                      F,
                      {
                        image: { src: k.src, alt: (k == null ? void 0 : k.alt) ?? "dada" },
                        className: "w-full h-full"
                      }
                    )
                  },
                  `${k.src}-${N}`
                ))
              }
            )
          ]
        }
      );
    }
  )
), yi = ({
  currentSlide: a,
  position: n,
  index: i,
  media: o,
  slots: s,
  videoSettings: c
}) => {
  const r = a !== i, l = _e(o), d = o.type === "image" && l("model_is_wearing", t.string()), m = o.type === "image" && l(De, t.boolean());
  return o ? /* @__PURE__ */ u(
    "div",
    {
      "data-is-active": a === i ? "true" : "false",
      className: `keen-slider__slide ${s.imageWrapper} relative`,
      children: [
        d && /* @__PURE__ */ e("div", { className: s.modelIsWearing, children: d.value }),
        m && /* @__PURE__ */ e(et, { media: o, className: s.shopTheLook }),
        o.type === "image" ? /* @__PURE__ */ e(
          F,
          {
            image: { src: o.src, alt: o.alt },
            className: s.image,
            fetchpriority: n < 2 ? "high" : "auto",
            loading: n < 2 ? "eager" : "lazy",
            displaySize: {
              mobile: "50vw",
              tablet: "80vw",
              desktop: "40vw"
            }
          }
        ) : /* @__PURE__ */ e(je, { src: o.src, loop: !0, autoPlay: !0, ...c }),
        r && /* @__PURE__ */ e("div", { className: s.peekingImage })
      ]
    },
    i
  ) : null;
}, tt = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  imageSettings: Re.optional(),
  CustomComponent: t.custom().optional()
}), Si = f(
  "ImageGalleryAsGrid",
  P(
    tt,
    ({ variants: a, imageSettings: n, CustomComponent: i }) => {
      const {
        content: { media: o }
      } = C(), s = Ot.styles(a), c = We(o, {
        key: Ke,
        value: [!1, void 0]
      });
      return /* @__PURE__ */ u("div", { className: s.base, children: [
        /* @__PURE__ */ e(Xe, { className: s.bundleSavingsBadge }),
        c.map(
          (r, l) => r && /* @__PURE__ */ e(
            wi,
            {
              media: r,
              CustomComponent: i,
              position: l,
              slots: s,
              imageSettings: n,
              amountOfImages: c.length
            },
            l
          )
        )
      ] });
    }
  )
), wi = ({
  media: a,
  slots: n,
  position: i,
  amountOfImages: o,
  imageSettings: s,
  CustomComponent: c
}) => {
  const r = _e(a), l = a.type === "image" && r("model_is_wearing", t.string()), d = a.type === "image" && r(De, t.boolean()), m = i === o - 1, g = o % 2 !== 0;
  return /* @__PURE__ */ u(
    "div",
    {
      className: n.imageWrapper,
      "data-has-shop-the-look": d ? "true" : "false",
      "data-has-model-is-wearing": l ? "true" : "false",
      "data-position": i,
      children: [
        l && /* @__PURE__ */ e("div", { className: n.modelIsWearing, children: l.value }),
        d && /* @__PURE__ */ e(et, { media: a, className: n.shopTheLook }),
        c && /* @__PURE__ */ e(c, { position: i, amountOfImages: o }),
        a.type === "image" ? /* @__PURE__ */ e(
          F,
          {
            image: { src: a.src, alt: a.alt },
            className: n.image,
            fetchpriority: i < 5 ? "high" : "auto",
            loading: i < 5 ? "eager" : "lazy",
            displaySize: {
              mobile: "90vw",
              tablet: "90vw",
              desktop: g && m ? "60vw" : "25vw"
            },
            ...s
          }
        ) : /* @__PURE__ */ e(je, { src: a.src, loop: !0, autoPlay: !0 })
      ]
    }
  );
}, at = t.discriminatedUnion("template", [
  Pe,
  tt
]), ki = f(
  "ImageGallery",
  P(at, (a) => a.template === "keen" ? /* @__PURE__ */ e(vi, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Si, { ...a }) : null)
), it = t.object({
  template: t.literal("table"),
  variants: t.custom().optional(),
  groupId: t.string().optional(),
  content: t.object({
    heading: t.string().optional(),
    headingTag: t.union([
      t.literal("h1"),
      t.literal("h2"),
      t.literal("h3"),
      t.literal("h4"),
      t.literal("h5"),
      t.literal("h6")
    ]).optional()
  }).optional()
}), _i = f(
  "ProductSpecificationsAsTable",
  P(
    {
      schema: it,
      defaultProps: {
        template: "table",
        groupId: "pdp_specifications"
      }
    },
    ({ variants: a, content: n, groupId: i }) => {
      const o = Rt.styles(a), s = (n == null ? void 0 : n.headingTag) || "h3", c = pa(
        i ?? "pdp_specifications"
      );
      return !c || !c.length ? null : /* @__PURE__ */ u("div", { className: o.base, children: [
        (n == null ? void 0 : n.heading) && /* @__PURE__ */ e(s, { className: o.heading, children: n.heading }),
        /* @__PURE__ */ e("ol", { className: o.tableWrapper, children: c.map((r, l) => /* @__PURE__ */ u("li", { className: o.row, children: [
          /* @__PURE__ */ u("span", { className: o.label, children: [
            (r == null ? void 0 : r.icon) && /* @__PURE__ */ e("span", { className: o.icon, children: r.icon }),
            r.label
          ] }),
          /* @__PURE__ */ e("span", { className: o.value, children: r.value })
        ] }, l)) })
      ] });
    }
  )
), nt = t.discriminatedUnion("template", [
  it
]), Ni = f(
  "ProductSpecifications",
  P(nt, (a) => a.template === "table" ? /* @__PURE__ */ e(_i, { ...a }) : null)
), Ti = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), Ie = t.object({
  template: t.literal("progress-bar"),
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional(),
  items: Ti.array().optional()
}), Bi = f(
  "AttributesAsProgressBar",
  P(
    Ie,
    ({
      variants: a,
      features: n = {
        onAScaleOf: 10
      },
      items: i
    }) => {
      const o = jt.styles(a), s = C(), c = $(s);
      if (!i)
        return null;
      const r = i.map((l) => {
        var m;
        const d = (m = c(l.attributeKey, t.string())) == null ? void 0 : m.value;
        if (d)
          return {
            label: l.label,
            score: parseInt(d),
            barColor: l.barColor
          };
      }).filter(Ta);
      return r.length === 0 ? null : /* @__PURE__ */ e("div", { className: o.base, children: r.map((l, d) => /* @__PURE__ */ u("div", { className: o.item, children: [
        /* @__PURE__ */ e("div", { className: o.label, children: l.label }),
        /* @__PURE__ */ e("div", { className: o.bar, children: /* @__PURE__ */ e(
          U.div,
          {
            className: o.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${l.score / n.onAScaleOf * 100}%`
            },
            exit: { width: 0 },
            transition: { delay: d * 0.16 },
            style: {
              backgroundColor: l.barColor
            }
          }
        ) }),
        /* @__PURE__ */ u("div", { className: o.scoreLabel, children: [
          l.score,
          "/",
          n.onAScaleOf
        ] })
      ] }, d)) });
    }
  )
), Bo = t.string(), ze = t.object({
  template: t.literal("tags"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional()
}), Ci = f(
  "AttributesAsTags",
  P(ze, ({ variants: a, attributeKey: n, label: i }) => {
    const o = Kt.styles(a), s = z(
      n,
      t.union([
        t.string(),
        t.array(t.string()),
        t.array(t.object({ description: t.string() }))
      ])
    );
    if (!s)
      return null;
    const c = Array.isArray(s.value) ? s.value : [s.value];
    return c.length ? /* @__PURE__ */ u("div", { className: o.base, children: [
      i && /* @__PURE__ */ e("span", { className: o.label, children: i }),
      /* @__PURE__ */ e("div", { className: o.tags, children: c.map((r, l) => /* @__PURE__ */ e("div", { className: o.tag, children: typeof r == "object" ? r.description : r }, `${r}-${l}`)) })
    ] }) : null;
  })
), ot = t.object({
  template: t.literal("icon-blocks"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional(),
  link: Ba.optional()
}), Ai = f(
  "AttributesAsIconBlocks",
  P(
    ot,
    ({ variants: a, attributeKey: n, label: i, link: o }) => {
      var r, l;
      const s = Mt.styles(a), c = (r = z(
        n,
        t.array(
          t.object({
            description: t.string().optional(),
            image: t.object({
              url: t.string()
            }).optional()
          })
        )
      )) == null ? void 0 : r.value;
      if (c)
        return /* @__PURE__ */ u("div", { className: s.base, children: [
          /* @__PURE__ */ u("div", { className: s.header, children: [
            i && /* @__PURE__ */ e("span", { className: s.label, children: i }),
            ((l = o == null ? void 0 : o.link) == null ? void 0 : l.href) && /* @__PURE__ */ e(Ca, { as: "a", className: s.link, ...o })
          ] }),
          /* @__PURE__ */ e("div", { className: s.blocks, children: c.map(
            (d, m) => {
              var g;
              return (g = d.image) != null && g.url ? /* @__PURE__ */ u(
                "div",
                {
                  className: s.block,
                  children: [
                    /* @__PURE__ */ e(
                      F,
                      {
                        className: s.icon,
                        image: {
                          src: d.image.url,
                          alt: d.description
                        }
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: s.description, children: d.description })
                  ]
                },
                `${d.description}-${m}`
              ) : null;
            }
          ) })
        ] });
    }
  )
), st = t.object({
  template: t.literal("row"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string().optional(),
  data: t.object({
    attributeLabel: t.string().optional(),
    value: t.string().optional()
  }).optional()
}), Di = f(
  "AttributesAsRow",
  P(st, ({ variants: a, attributeKey: n, data: i }) => {
    const o = Ht.styles(a), s = _(), c = z(n || "", t.string()), { attributeLabel: r, value: l } = c || i || {};
    return !c && !i ? null : /* @__PURE__ */ u("div", { className: o.base, children: [
      r && /* @__PURE__ */ e("label", { className: o.label, children: s(r) }),
      /* @__PURE__ */ e("h4", { className: o.value, children: l })
    ] });
  })
), Ii = t.discriminatedUnion("template", [
  Ie,
  ze,
  ot,
  st
]), zi = f(
  "ProductAttributes",
  P(Ii, (a) => a.template === "progress-bar" ? /* @__PURE__ */ e(Bi, { ...a }) : a.template === "tags" ? /* @__PURE__ */ e(Ci, { ...a }) : a.template === "icon-blocks" ? /* @__PURE__ */ e(Ai, { ...a }) : a.template === "row" ? /* @__PURE__ */ e(Di, { ...a }) : null)
), Li = ({ className: a }) => /* @__PURE__ */ u(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), xi = ({ className: a }) => /* @__PURE__ */ u(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), Gi = t.object({
  setDisplayGoToCheckoutButton: t.custom(),
  amount: t.number(),
  slots: t.custom(),
  increaseButtonSettings: te.optional(),
  decreaseButtonSettings: te.optional()
}), Wi = f(
  "AddToCartQuanityPickerRow",
  P(
    Gi,
    ({
      setDisplayGoToCheckoutButton: a,
      slots: n,
      amount: i,
      decreaseButtonSettings: o,
      increaseButtonSettings: s
    }) => {
      const {
        addToCartMethod: c,
        removeFromCartMethod: r,
        quantityInCart: l,
        isAvailable: d
      } = fe(), m = _();
      function g(v) {
        c.execute(v), a(!0);
      }
      return /* @__PURE__ */ u("div", { className: n.quantityPickerWrapper, children: [
        /* @__PURE__ */ e(
          oe,
          {
            ...o,
            disabled: l < i,
            progress: r.loadingState,
            onClick: () => r.execute(i)
          }
        ),
        /* @__PURE__ */ u("div", { className: n.quantityDisplay, children: [
          /* @__PURE__ */ e("span", { className: n.quantityText, children: i }),
          /* @__PURE__ */ e("span", { className: n.quantityUnit, children: m("PDP_Quantity_Picker_Suffix") })
        ] }),
        /* @__PURE__ */ e(
          oe,
          {
            ...s,
            progress: c.loadingState,
            disabled: !d,
            onClick: () => g(i)
          }
        )
      ] });
    }
  )
), rt = t.object({
  template: t.literal("quantity-picker"),
  variants: t.custom().optional(),
  features: t.object({
    increaseButtonSettings: te.optional(),
    decreaseButtonSettings: te.optional(),
    itemSuffix: t.string().optional(),
    /** An optional boolean that determines whether the price should be displayed. @default true */
    showPrice: t.boolean().optional(),
    /** An optional array of numbers that defines the quantity options for adding items to the cart @default [1, 10] */
    addQuantityOptions: t.array(t.number()).optional(),
    postAddAction: t.union([t.literal("goToCheckoutButton"), t.literal("none")]).optional()
  }).optional()
}), Oi = f(
  "AddToCartQuantityPicker",
  P(
    {
      schema: rt,
      defaultProps: {
        template: "quantity-picker",
        features: {
          showPrice: !0,
          addQuantityOptions: [1, 10],
          postAddAction: "goToCheckoutButton",
          increaseButtonSettings: {
            variants: {
              width: "auto",
              size: "md",
              color: "primary"
            },
            iconRight: /* @__PURE__ */ e(xi, { className: "w-3 h-3" }),
            label: "Add"
          },
          decreaseButtonSettings: {
            variants: {
              width: "same-as-height",
              size: "md",
              color: "white"
            },
            iconLeft: /* @__PURE__ */ e(Li, { className: "w-3 h-3" })
          }
        }
      }
    },
    ({ variants: a, features: n }) => {
      var y;
      const i = le(), o = Et.styles(a), [s, c] = G(!1), r = _(), [l, d] = G(0);
      Se(null);
      const {
        addToCartMethod: m,
        removeFromCartMethod: g,
        quantityInCart: v,
        isAvailable: b
      } = fe(), h = () => {
        l && (l > v ? (m.execute(l - v), c(!0)) : l < v && g.execute(v - l));
      };
      return x(() => {
        d(0);
      }, [v]), /* @__PURE__ */ u("div", { className: o.base, children: [
        /* @__PURE__ */ u("div", { className: o.innerWrapper, children: [
          (n == null ? void 0 : n.showPrice) && /* @__PURE__ */ u(R, { children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: o.priceTag,
                "data-is-discounted": i.discountInfo ? "true" : "false",
                children: i.price.formatted
              }
            ),
            i.discountInfo && /* @__PURE__ */ e("span", { className: o.oldPriceTag, children: i.priceWithoutDiscount.formatted })
          ] }),
          /* @__PURE__ */ e("div", { className: o.currentQuantityWrapper, children: /* @__PURE__ */ u("div", { className: o.currentQuantityInputWrapper, children: [
            /* @__PURE__ */ e(
              "form",
              {
                onSubmit: (w) => {
                  w.preventDefault(), h();
                },
                children: /* @__PURE__ */ e(
                  "input",
                  {
                    onChange: (w) => {
                      w.preventDefault(), d(parseInt(w.target.value));
                    },
                    value: l > 0 ? l : "",
                    className: o.currentQuantityInput,
                    placeholder: v.toString(),
                    min: "0",
                    type: "number",
                    enterKeyHint: "done",
                    autoComplete: "off",
                    autoCorrect: "off",
                    spellCheck: "false"
                  }
                )
              }
            ),
            l > 0 ? /* @__PURE__ */ e(
              oe,
              {
                disabled: !b,
                onClick: h,
                className: o.updateButton,
                progress: l > v ? m.loadingState : g.loadingState,
                variants: {
                  size: "md",
                  width: "same-as-height"
                },
                label: r("PDP_Quantity_Picker_Update")
              }
            ) : /* @__PURE__ */ e("span", { className: o.currentQuantityUnit, children: r("PDP_Quantity_Picker_Suffix") })
          ] }) }),
          /* @__PURE__ */ e("div", { className: o.quantityPickersWrapper, children: (y = n == null ? void 0 : n.addQuantityOptions) == null ? void 0 : y.map((w, S) => /* @__PURE__ */ e(
            Wi,
            {
              increaseButtonSettings: n.increaseButtonSettings,
              decreaseButtonSettings: n.decreaseButtonSettings,
              amount: w,
              slots: o,
              setDisplayGoToCheckoutButton: c
            },
            S
          )) })
        ] }),
        /* @__PURE__ */ e(ee, { children: s && /* @__PURE__ */ e(
          U.div,
          {
            initial: { marginTop: -50 },
            animate: { marginTop: 0 },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ e(
              q,
              {
                as: "a",
                variants: {
                  width: "full",
                  style: "solid",
                  color: "black"
                },
                label: r("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), lt = {
  available: "PDP_Add_To_Cart",
  "out-of-stock": "PDP_Out_Of_Stock",
  discontinued: "PDP_Discontinued",
  "not-determined": "PDP_Select_Size"
}, Ri = (a) => {
  const n = ge(), i = _(), o = n.status === "out-of-stock" && a ? i("Notify_Me_Submit_Label") : i(lt[n.status]) ?? "PDP_Select_Size";
  return i(o);
}, ct = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: te.optional(),
  animateAddToCartLabel: t.boolean().optional(),
  postAddAction: t.union([
    t.literal("goToCheckoutButton"),
    t.literal("showMinicart"),
    t.literal("none")
  ]).optional(),
  isNotifyMeEnabled: t.boolean().optional()
}), ji = f(
  "AddToCartButton",
  P(
    {
      schema: ct,
      defaultProps: {
        template: "button",
        animateAddToCartLabel: !0,
        postAddAction: "showMinicart",
        isNotifyMeEnabled: !1
      }
    },
    ({
      variants: a,
      buttonSettings: n,
      animateAddToCartLabel: i,
      postAddAction: o,
      isNotifyMeEnabled: s
    }) => {
      const c = Vt.styles(a), { addToCartMethod: r, isAvailable: l, isOutOfStock: d, isDiscontinued: m } = fe(), g = d && s, v = Ri(g), b = _(), h = typeof window < "u" && window.location.pathname.includes("/checkout"), [y, w] = G(!1), S = we(async () => {
        if (!m) {
          if (d && s) {
            X.emit("open", { overlayId: "notify-me" });
            return;
          } else if (!l) {
            La.error(b("Add_To_Cart_Error_Not_Available_Toast"));
            return;
          }
          await r.execute(), o === "goToCheckoutButton" && w(!0), o === "showMinicart" && !h && X.emit("open", { overlayId: "mini-cart" });
        }
      }, [
        d,
        s,
        r,
        o,
        b,
        h
      ]), B = Dt(
        () => i ? /* @__PURE__ */ e(ee, { mode: "wait", initial: !1, children: /* @__PURE__ */ e(
          U.span,
          {
            exit: {
              y: "-190%",
              opacity: 0.7,
              transition: {
                duration: 0.15
              }
            },
            initial: {
              y: "150%",
              opacity: 0.7
            },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                duration: 0.15
              }
            },
            children: v
          },
          v
        ) }) : v,
        [i, v]
      );
      return /* @__PURE__ */ u("div", { className: c.base, id: "add-to-cart-component", children: [
        /* @__PURE__ */ e(
          q,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...n,
            progress: r.loadingState,
            dataAttr: {
              "appear-disabled": (d || m) && !g
            },
            "aria-disabled": !l && !g ? "true" : "false",
            label: B,
            onClick: S
          }
        ),
        /* @__PURE__ */ e(ee, { initial: !1, children: y && /* @__PURE__ */ e(
          U.div,
          {
            initial: { y: "-100%" },
            animate: { y: 0 },
            transition: {
              duration: 0.5,
              ease: He(0.32, 0.72, 0, 1)
            },
            children: /* @__PURE__ */ e(
              q,
              {
                as: "a",
                variants: {
                  width: "full",
                  color: "black",
                  style: "outline"
                },
                label: b("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), dt = t.discriminatedUnion("template", [
  rt,
  ct
]), Ki = f(
  "ProductAddToCart",
  P(dt, (a) => W() === "bundle" ? null : a.template === "button" ? /* @__PURE__ */ e(ji, { ...a }) : a.template === "quantity-picker" ? /* @__PURE__ */ e(Oi, { ...a }) : null)
), ce = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  notifyMe: t.object({
    enabled: t.boolean().optional(),
    icon: t.custom().optional()
  }).optional(),
  lowStockIndicator: t.object({
    /**
     * Enables/disables the low stock indicator functionality
     * @default false
     */
    enabled: t.boolean().optional(),
    /**
     * Display a component to indicate low stock
     */
    headerContent: t.custom().optional(),
    /**
     * Threshold value below which stock is considered low
     * Triggers visual indicator when stock drops below this number
     * @default 5
     */
    lowStockLimit: t.number().optional()
  }).optional(),
  headerContent: t.custom().optional()
}), Mi = f(
  "SizePickerButtonGrid",
  P(
    ce,
    ({ variants: a, notifyMe: n, lowStockIndicator: i, headerContent: o }) => {
      var h;
      const s = Ut.styles(a), { optionGroups: c, selectOption: r, selectedOptions: l } = Te(), d = _(), m = c.length === 1 && ((h = c[0]) == null ? void 0 : h.options.length) === 1;
      if (m)
        return null;
      x(() => {
        var y;
        m && ((y = c[0]) != null && y.options[0]) && r(
          c[0].dimensionKey,
          c[0].options[0]
        );
      }, []);
      const g = (i == null ? void 0 : i.lowStockLimit) ?? 5, v = (y) => (i == null ? void 0 : i.enabled) === !0 && y.inventory.inStock && y.inventory.quantity < g, b = c.some(
        (y) => y.options.some(v)
      );
      return /* @__PURE__ */ u("div", { className: s.base, children: [
        /* @__PURE__ */ u("div", { className: s.header, children: [
          /* @__PURE__ */ e("span", { children: d("PDP_Size_Picker_Select_Size") }),
          b ? i == null ? void 0 : i.headerContent : o
        ] }),
        c.map((y) => /* @__PURE__ */ e("div", { className: s.wrapper, children: y.options.map((w) => {
          var T;
          const S = ((T = l[y.dimensionKey]) == null ? void 0 : T.dimensionValue) === w.dimensionValue, B = w.inventory.inStock, A = v(w), I = () => {
            r(y.dimensionKey, w);
          };
          return /* @__PURE__ */ u(
            "button",
            {
              type: "button",
              "data-is-selected": S ? "true" : "false",
              "data-is-out-of-stock": B ? "false" : "true",
              disabled: !B && !(n != null && n.enabled),
              className: s.size,
              "aria-label": w.label,
              onClick: I,
              children: [
                A && (i == null ? void 0 : i.enabled) && /* @__PURE__ */ e("span", { className: s.lowStockIndicator }),
                (n == null ? void 0 : n.enabled) && !B && n.icon,
                w.label
              ]
            },
            w.dimensionValue
          );
        }) }, y.dimensionKey))
      ] });
    }
  )
), Hi = {
  direction: "right",
  variants: {
    rounded: "none"
  }
}, Ei = {
  style: "outline",
  width: "full"
}, se = t.object({
  template: t.literal("modal"),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttonVariants: t.custom().optional().describe("Variants for the button"),
  triggerLabel: t.string().optional(),
  sizeButtons: ke.optional(),
  aboveButtonComponent: t.custom().optional(),
  belowButtonComponent: t.custom().optional(),
  customOverlayId: t.string().optional()
}), Vi = () => {
  const [a, n] = G(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return x(() => {
    const i = () => {
      n(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, []), a;
}, Ui = f(
  "SizePickerModal",
  P(
    {
      schema: se,
      defaultProps: {
        template: "modal",
        drawerSettings: Hi,
        buttonVariants: Ei,
        sizeButtons: {
          variants: {
            rounded: "full",
            width: "same-as-height",
            size: "md",
            color: "black",
            style: "outline"
          }
        },
        customOverlayId: "size-picker-modal"
      }
    },
    ({
      variants: a,
      drawerSettings: n,
      buttonVariants: i,
      triggerLabel: o,
      sizeButtons: s,
      aboveButtonComponent: c,
      belowButtonComponent: r,
      customOverlayId: l
    }) => {
      const d = _(), m = Vi(), g = $t.styles(a), { optionGroups: v, selectOption: b, selectedOptions: h } = Te();
      return /* @__PURE__ */ u(
        D,
        {
          hasOverlay: !0,
          ...n,
          variants: {
            direction: m ? "right" : "bottom",
            ...(n ?? {}).variants
          },
          customOverlayId: l ?? "size-picker-modal",
          direction: m ? "right" : "bottom",
          children: [
            /* @__PURE__ */ e(D.Trigger, { className: g.trigger, children: /* @__PURE__ */ e(
              Ee,
              {
                label: o ?? d("Size_Picker_Select_Size"),
                variants: i
              }
            ) }),
            /* @__PURE__ */ u(D.Content, { children: [
              /* @__PURE__ */ e("div", { className: g.optionsWrapper, children: v.map((y) => /* @__PURE__ */ u(
                "div",
                {
                  className: g.wrapper,
                  "data-dimension-key": y.dimensionKey,
                  "data-dimension-label": y.dimensionLabel,
                  children: [
                    /* @__PURE__ */ e("div", { className: g.header, children: /* @__PURE__ */ e("h3", { className: g.heading, children: d(`Size_Picker_${y.dimensionLabel}`) }) }),
                    /* @__PURE__ */ e("div", { className: g.sizeWrapper, children: y.options.map((w, S) => {
                      var A;
                      const B = ((A = h[y.dimensionKey]) == null ? void 0 : A.dimensionValue) === w.dimensionValue;
                      return /* @__PURE__ */ e(
                        oe,
                        {
                          dataAttr: {
                            "is-selected": B,
                            "is-out-of-stock": !w.inventory.inStock
                          },
                          className: g.size,
                          onClick: () => b(y.dimensionKey, w),
                          label: w.label,
                          ...s
                        },
                        `${w.label}-${S}`
                      );
                    }) })
                  ]
                },
                y.dimensionKey
              )) }),
              c,
              /* @__PURE__ */ e(p.AddToCart, { template: "button" }),
              r
            ] })
          ]
        }
      );
    }
  )
), $i = t.discriminatedUnion("template", [
  ce,
  se
]), Fi = f(
  "ProductSizePicker",
  P($i, (a) => W() !== "with_variants" ? null : a.template === "button-grid" ? /* @__PURE__ */ e(Mi, { ...a }) : a.template === "modal" ? /* @__PURE__ */ e(Ui, { ...a }) : null)
), Le = t.object({
  template: t.literal("image-card"),
  colorAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  hide: t.boolean().optional()
}), Qi = f(
  "SiblingsImageCard",
  P(
    {
      schema: Le,
      defaultProps: {
        template: "image-card",
        colorAttributeKey: "product_color",
        headingTag: "h2"
      }
    },
    ({ variants: a, colorAttributeKey: n, headingTag: i }) => {
      const o = _(), s = Ft.styles(a), c = z(
        n ?? "",
        t.string()
      ), r = C(), l = Oe(), d = i ?? "h2";
      return l.length ? /* @__PURE__ */ u("div", { className: s.base, children: [
        c && /* @__PURE__ */ e(d, { className: s.header, children: o("PDP_Siblings_Header_Title", {
          color: c.value,
          colorName: c.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: s.siblingsWrapper, children: l.map((m, g) => {
          var v, b, h, y, w, S;
          return (h = (b = (v = m.content) == null ? void 0 : v.media) == null ? void 0 : b[0]) != null && h.src ? /* @__PURE__ */ e(
            re,
            {
              productBase: m,
              context: "product-sibling",
              className: s.sibling,
              "data-is-selected": m.productId === r.productId,
              children: /* @__PURE__ */ e(
                F,
                {
                  image: { src: (S = (w = (y = m.content) == null ? void 0 : y.media) == null ? void 0 : w[0]) == null ? void 0 : S.src },
                  displaySize: {
                    mobile: "80px",
                    tablet: "80px",
                    desktop: "80px"
                  },
                  className: s.siblingImage
                }
              )
            },
            g
          ) : null;
        }) })
      ] }) : null;
    }
  )
), qi = (a) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(a), Zi = (a) => /^[a-zA-Z]+$/.test(a) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(a), Yi = (a) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(a) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(a), Ji = (a) => a.startsWith("http") || a.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(a), ut = ({
  sibling: a,
  colorSwatchAttributeKey: n,
  className: i
}) => {
  const o = C(), s = $(a);
  if (!n)
    return null;
  const c = s(
    n,
    t.string()
  );
  if (!(c != null && c.valueLabel))
    return null;
  const r = c.valueLabel, l = c.value, d = () => l ? Ji(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : qi(l) || Zi(l) || Yi(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {}, m = `${r || ""} color option`;
  return /* @__PURE__ */ e(
    re,
    {
      productBase: a,
      context: "product-sibling",
      className: i,
      style: d(),
      "data-is-selected": o.productId === a.productId,
      "data-is-white": l === "#ffffff" || (r == null ? void 0 : r.toLocaleLowerCase()) === "white" || (r == null ? void 0 : r.toLocaleLowerCase()) === "vit",
      "aria-label": m,
      title: r || "",
      role: "button",
      "data-testid": `color-swatch-${r == null ? void 0 : r.toLowerCase().replace(/\s+/g, "-")}`
    },
    a.productKey
  );
}, pt = t.object({
  template: t.literal("color-swatch"),
  colorSwatchAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  hide: t.boolean().optional()
}), Xi = f(
  "SiblingColorSwatchList",
  P(
    {
      schema: pt,
      defaultProps: {
        template: "color-swatch",
        colorSwatchAttributeKey: "product_color"
      }
    },
    ({ variants: a, colorSwatchAttributeKey: n }) => {
      const i = Qt.styles(a), o = C(), s = _(), c = Oe(), r = $(o);
      if (!n || !c.length)
        return null;
      const l = r(
        n,
        t.string()
      );
      return l ? /* @__PURE__ */ u("div", { className: i.base, children: [
        /* @__PURE__ */ e("div", { className: i.header, children: s("PDP_Product_ColorSwatch_Label", {
          color: l.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: i.siblingsWrapper, children: c.map((d, m) => /* @__PURE__ */ e(
          ut,
          {
            sibling: d,
            colorSwatchAttributeKey: n,
            className: i.sibling
          },
          `sibling.productKey-${m}`
        )) })
      ] }) : null;
    }
  )
), de = t.discriminatedUnion("template", [
  Le,
  pt
]), en = f(
  "ProductSiblings",
  P(de, (a) => a.hide === !0 ? null : a.template === "image-card" ? /* @__PURE__ */ e(Qi, { ...a }) : a.template === "color-swatch" ? /* @__PURE__ */ e(Xi, { ...a }) : null)
), mt = t.object({
  template: t.literal("image-cards"),
  swiperSettings: Ue.optional(),
  relationType: t.string().optional(),
  productCardSettings: xa.optional()
}), tn = (a) => {
  const n = Wa(), i = _();
  if (!n || n.length === 0)
    return null;
  const o = qt.styles();
  return /* @__PURE__ */ u("div", { className: o.base, children: [
    /* @__PURE__ */ e("h3", { className: o.heading, children: i("PDP_Related_Products_Image_Cards_Heading") }),
    /* @__PURE__ */ e("div", { className: o.wrapper, children: n.slice(0, 3).map((s, c) => s.type !== "product" ? null : /* @__PURE__ */ e(
      Ne,
      {
        product: s.product,
        context: {
          type: "plp",
          listId: "related-products",
          listName: "Related Products",
          position: c
        },
        children: /* @__PURE__ */ e(Ga, { templateProps: a.productCardSettings })
      },
      c
    )) })
  ] });
}, ht = f(
  "ProductRelatedProductsImageCards",
  P(mt, ({ relationType: a, ...n }) => {
    const i = be(a);
    if (!ht.length)
      return null;
    const o = {
      items: i.map((s) => ({ type: "product", product: s.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: i.length
      },
      facets: [],
      sort: []
    };
    return /* @__PURE__ */ e(Ve, { result: o, children: /* @__PURE__ */ e(tn, { ...n }) });
  })
), bt = t.object({
  template: t.literal("swiper"),
  swiperSettings: Ue.optional(),
  relationType: t.string().optional()
}), an = f(
  "ProductRelatedProductsSwiper",
  P(bt, ({ swiperSettings: a, relationType: n }) => {
    const i = be(n);
    if (!i.length)
      return null;
    const o = {
      items: i.map((s) => ({ type: "product", product: s.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: i.length
      },
      sort: [],
      facets: []
    };
    return /* @__PURE__ */ e(Ve, { result: o, children: /* @__PURE__ */ e(Oa, { ...a }) });
  })
), Y = t.discriminatedUnion("template", [
  mt,
  bt
]), nn = f(
  "RelatedProducts",
  P(Y, (a) => a.template === "image-cards" ? /* @__PURE__ */ e(ht, { ...a }) : a.template === "swiper" ? /* @__PURE__ */ e(an, { ...a }) : null)
), on = ({
  targetSelector: a,
  mode: n = "isNotVisible"
}) => {
  const [i, o] = G(!1), s = Se(null), c = Se(null);
  x(() => {
    if (n === "isAlwaysVisible") {
      o(!0);
      return;
    } else if (n === "isAlwaysHidden") {
      o(!1);
      return;
    }
  }, [n]);
  const r = we(() => {
    if (!s.current)
      return;
    const d = s.current.getBoundingClientRect();
    switch (n) {
      case "isScrolledPast":
        o(d.bottom <= 0);
        break;
      case "isBeforeView":
        o(d.top >= window.innerHeight);
        break;
    }
  }, [n]), l = we(() => {
    c.current && cancelAnimationFrame(c.current), c.current = requestAnimationFrame(() => {
      r(), c.current = null;
    });
  }, [r]);
  return x(() => {
    if (n === "isAlwaysVisible" || n === "isAlwaysHidden" || (s.current = document.querySelector(a), !s.current))
      return;
    let d = null;
    return n === "isVisible" || n === "isNotVisible" ? (d = new IntersectionObserver(
      ([m]) => {
        m && o(
          n === "isVisible" ? m.isIntersecting : !m.isIntersecting
        );
      },
      { threshold: 0.1 }
    ), d.observe(s.current)) : (r(), window.addEventListener("scroll", l, { passive: !0 }), window.addEventListener("resize", l, { passive: !0 })), () => {
      d ? d.disconnect() : (window.removeEventListener("scroll", l), window.removeEventListener("resize", l)), c.current && cancelAnimationFrame(c.current);
    };
  }, [a, n, r, l]), i;
}, gt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: te.optional(),
  mode: t.custom().optional(),
  targetSelector: t.string().optional(),
  selectSizeAction: t.union([t.literal("open-size-picker"), t.literal("scroll-to-size-picker")]).optional(),
  withSizePicker: t.boolean().optional(),
  sizePickerOverlayId: t.string().optional(),
  showPrice: t.boolean().optional()
}), sn = f(
  "StickyAddToCartButton",
  P(
    {
      schema: gt,
      defaultProps: {
        template: "button",
        mode: "isScrolledPast",
        targetSelector: "#add-to-cart-component",
        selectSizeAction: "scroll-to-size-picker",
        withSizePicker: !1,
        sizePickerOverlayId: "size-picker-modal",
        showPrice: !0
      }
    },
    ({
      variants: a,
      buttonSettings: n,
      mode: i,
      targetSelector: o,
      selectSizeAction: s,
      withSizePicker: c,
      sizePickerOverlayId: r,
      showPrice: l
    }) => {
      const d = Zt.styles(a), { addToCartMethod: m, isAvailable: g } = fe(), v = ge(), b = _(), { selectedOptions: h } = Te(), y = Object.values(h).filter((T) => !!T).map((T) => T.label).join(" / "), w = le(), S = on({
        targetSelector: o ?? "#add-to-cart-component",
        mode: i
      }), B = typeof window < "u" && window.location.pathname.includes("/checkout"), A = () => {
        X.emit("open", {
          overlayId: r ?? "size-picker-modal"
        });
      }, I = async () => {
        if (!g) {
          if (s === "open-size-picker") {
            A();
            return;
          }
          if (s === "scroll-to-size-picker") {
            const T = document.getElementById("add-to-cart-component");
            T == null || T.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            return;
          }
        }
        await m.execute(), B || X.emit("open", { overlayId: "mini-cart" });
      };
      return v.status === "out-of-stock" ? null : c ? /* @__PURE__ */ e(
        "div",
        {
          className: d.base,
          "data-is-visible": S ? "true" : "false",
          children: /* @__PURE__ */ u("div", { className: d.buttonsWrapper, children: [
            /* @__PURE__ */ e(
              q,
              {
                as: "button",
                variants: {
                  width: "full",
                  style: "outline",
                  color: "black"
                },
                label: g ? y : b("PDP_Select_Size"),
                onClick: A
              }
            ),
            /* @__PURE__ */ e(
              q,
              {
                as: "button",
                variants: {
                  width: "full"
                },
                ...n,
                progress: m.loadingState,
                label: /* @__PURE__ */ u(R, { children: [
                  b("PDP_Add_To_Cart"),
                  l && /* @__PURE__ */ u(R, { children: [
                    " ",
                    /* @__PURE__ */ e("span", { children: w.price.formatted })
                  ] })
                ] }),
                onClick: I
              }
            )
          ] })
        }
      ) : /* @__PURE__ */ e(
        "div",
        {
          className: d.base,
          "data-is-visible": S ? "true" : "false",
          children: /* @__PURE__ */ e(
            q,
            {
              as: "button",
              variants: {
                width: "full",
                justifyContent: "between"
              },
              ...n,
              progress: m.loadingState,
              label: /* @__PURE__ */ u(R, { children: [
                b(g ? "PDP_Add_To_Cart" : "PDP_Select_Size"),
                l && /* @__PURE__ */ u(R, { children: [
                  " ",
                  /* @__PURE__ */ e("span", { children: w.price.formatted })
                ] })
              ] }),
              onClick: I
            }
          )
        }
      );
    }
  )
), rn = t.discriminatedUnion("template", [
  gt
]), ln = f(
  "ProductStickyAddToCart",
  P(rn, (a) => W() !== "with_variants" ? null : a.template === "button" ? /* @__PURE__ */ e(sn, { ...a }) : null)
), cn = () => W() !== "bundle" ? null : /* @__PURE__ */ e(dn, {}), dn = () => {
  const { sections: a } = Be(), n = me.styles();
  return /* @__PURE__ */ u("div", { className: n.base, children: [
    /* @__PURE__ */ e("div", { className: n.sectionsWrapper, children: Object.values(a).map((i, o) => /* @__PURE__ */ e(
      Ne,
      {
        product: i.activeProduct.product,
        context: {
          type: "plp",
          listId: "bundle-section",
          listName: "Bundle Section",
          position: o
        },
        children: /* @__PURE__ */ e(un, { section: i, index: o })
      },
      o
    )) }),
    /* @__PURE__ */ e(hn, {}),
    /* @__PURE__ */ e(bn, {})
  ] });
}, un = ({
  section: a,
  index: n
}) => {
  const i = C(), { selectSectionProduct: o } = Be(), s = me.styles(), c = _(), r = (l) => {
    o(a.sectionId, l);
  };
  return /* @__PURE__ */ u("div", { className: s.section, children: [
    /* @__PURE__ */ e(ee, { mode: "wait", initial: !1, children: /* @__PURE__ */ e("div", { className: s.productNameWrapper, children: /* @__PURE__ */ e(
      U.h3,
      {
        className: s.productName,
        exit: {
          y: "-100%"
        },
        initial: {
          y: "100%"
        },
        animate: {
          y: 0
        },
        transition: {
          duration: 0.35,
          ease: He(0.32, 0.72, 0, 1)
        },
        children: c("PDP_Bundle_Selection_Product", {
          index: n + 1,
          product: i.content.name
        })
      }
    ) }, i.content.name) }),
    /* @__PURE__ */ e("h3", { className: s.selectionHeading, children: c("PDP_Bundle_Selection_Heading") }),
    /* @__PURE__ */ e("div", { className: s.productSlider, children: a.products.map((l, d) => {
      const m = l.base.productId === a.activeProduct.product.base.productId;
      return /* @__PURE__ */ e(
        pn,
        {
          product: l,
          isSelected: m,
          onClick: () => r(l)
        },
        d
      );
    }) }),
    /* @__PURE__ */ e(mn, { sectionId: a.sectionId }),
    /* @__PURE__ */ e(
      Aa,
      {
        link: { href: a.activeProduct.product.base.slug },
        label: c("PDP_Bundle_Selection_Link"),
        className: s.link
      }
    )
  ] });
}, pn = ({
  product: a,
  isSelected: n,
  onClick: i
}) => {
  var l;
  const o = me.styles(), s = (l = a.base.content.media) == null ? void 0 : l[0], r = $(a.base)("product_color", t.string());
  return /* @__PURE__ */ u(
    "button",
    {
      className: o.productWrapper,
      onClick: i,
      "data-is-selected": n ? "true" : "false",
      children: [
        s && /* @__PURE__ */ e(F, { className: o.productImage, image: s }),
        r && /* @__PURE__ */ u("div", { className: o.swatchWrapper, children: [
          /* @__PURE__ */ e(
            ut,
            {
              sibling: a.base,
              colorSwatchAttributeKey: "colorSwatch",
              className: o.swatch
            }
          ),
          /* @__PURE__ */ e("span", { className: o.swatchLabel, children: r == null ? void 0 : r.valueLabel })
        ] })
      ]
    }
  );
}, mn = ({ sectionId: a }) => {
  const n = W(), i = ge(), { selectSectionSize: o } = Be(), s = _(), c = i.status === "available" ? i.availableItemId : void 0;
  switch (x(() => {
    o(a, c);
  }, [c]), n) {
    case "with_variants":
      return /* @__PURE__ */ e(p.SizePicker, { template: "button-grid" });
    case "simple":
      return /* @__PURE__ */ e(
        "button",
        {
          "data-is-selected": i.status === "out-of-stock" ? "false" : "true",
          "data-is-out-of-stock": i.status === "out-of-stock" ? "true" : "false",
          className: "w-1/2 h-10 text-label-sm uppercase font-medium bg-transparent rounded-md border data-[is-out-of-stock=true]:text-less-emphasis-3 data-[is-selected=true]:text-white data-[is-selected=true]:bg-black relative data-[is-out-of-stock=true]:before:absolute data-[is-out-of-stock=true]:before:w-[1px] data-[is-out-of-stock=true]:before:h-[140%] data-[is-out-of-stock=true]:before:bg-less-emphasis-3 data-[is-out-of-stock=true]:before:top-[-20%] before:left-1/2 before:-translate-x-1/2 before:rotate-45 [&>svg]:w-5 [&>svg]:h-5",
          children: s("PDP_Size_Picker_One_Size")
        }
      );
    default:
      return null;
  }
}, hn = () => {
  const a = he(), n = me.styles(), i = _();
  return /* @__PURE__ */ u("div", { className: n.totalsWrapper, children: [
    /* @__PURE__ */ u("div", { className: n.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: n.totalsLabel, children: i("PDP_Bundle_Discount_Label") }),
      /* @__PURE__ */ u("span", { className: n.totalsValue, children: [
        "-",
        a.discountFromPriceOfItemsOutsideBundle.formatted
      ] })
    ] }),
    /* @__PURE__ */ u("div", { className: n.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: n.totalsLabel, children: i("PDP_Bundle_Price_Label") }),
      /* @__PURE__ */ e("span", { className: n.totalsValue, children: a.priceInfo.price.formatted })
    ] })
  ] });
}, bn = () => {
  const a = ma(), n = ha(), { execute: i } = ka("addBundleToCart"), [o, s] = pe.useState("default"), c = _(), r = async () => {
    if (n.status === "available")
      try {
        s("loading"), await i({
          itemId: a,
          sections: n.sections.map((d) => ({
            sectionId: d.sectionId,
            itemId: d.availableItemId
          }))
        }), await new Promise((d) => setTimeout(d, 1e3)), s("complete"), await new Promise((d) => setTimeout(d, 1e3));
      } catch {
        s("default"), await new Promise((m) => setTimeout(m, 1e3));
      } finally {
        s("default"), X.emit("open", { overlayId: "mini-cart" });
      }
  }, l = n.status === "available";
  return /* @__PURE__ */ e(
    q,
    {
      as: "button",
      variants: {
        width: "full"
      },
      progress: o,
      "aria-disabled": l ? "false" : "true",
      label: c(lt[n.status]),
      onClick: r
    }
  );
}, ie = t.object({
  items: t.array(
    t.object({
      label: t.string().optional(),
      icon: t.custom().optional()
    })
  ).optional(),
  attributeKey: t.string().optional(),
  variants: t.custom().optional()
}), gn = f(
  "ProductUspBlock",
  P(
    {
      schema: ie,
      defaultProps: {
        attributeKey: "usps"
      }
    },
    ({ items: a, variants: n, attributeKey: i }) => {
      var c, r;
      const o = Yt.styles(n), s = (c = z(
        i ?? "usps",
        t.array(
          t.object({
            label: t.string(),
            icon: t.string().optional()
          })
        )
      )) == null ? void 0 : c.value;
      return !a && !s ? null : /* @__PURE__ */ e("div", { className: o.base, children: (r = a ?? s) == null ? void 0 : r.map((l, d) => /* @__PURE__ */ u("div", { className: o.item, children: [
        l.icon,
        /* @__PURE__ */ e("span", { className: o.label, children: l.label })
      ] }, d)) });
    }
  )
), ft = t.object({
  template: t.literal("scale"),
  variants: t.custom().optional(),
  /**
   * On a scale of. @default 10
   * @type {number}
   *  */
  onAScaleOf: t.number().optional()
}), fn = f(
  "ProductSizeRecommendationScale",
  P(
    {
      schema: ft,
      defaultProps: {
        template: "scale",
        onAScaleOf: 10
      }
    },
    ({ onAScaleOf: a }) => {
      C();
      const n = Jt.styles(), i = _(), o = z(
        "sizeRecommendation",
        t.string()
      ), s = z(
        "sizeRecommendationScale",
        t.string()
      );
      if (!(!(s != null && s.value) || !(o != null && o.value)))
        return /* @__PURE__ */ u("div", { className: n.base, children: [
          (s == null ? void 0 : s.value) && s.value && /* @__PURE__ */ u(R, { children: [
            /* @__PURE__ */ e("h3", { className: n.label, children: i("PDP_Size_Recommendation_Scale_Label") }),
            /* @__PURE__ */ e("div", { className: n.bar, children: /* @__PURE__ */ e(
              U.div,
              {
                className: n.dot,
                initial: {
                  left: `${parseInt(s.value) / (a ?? 10) * 100}%`,
                  scale: 0
                },
                whileInView: {
                  scale: 1
                },
                transition: {
                  delay: 0.25
                },
                exit: { scale: 0 }
              }
            ) }),
            /* @__PURE__ */ u("div", { className: n.scaleLabels, children: [
              /* @__PURE__ */ e("span", { className: n.scaleLabel, children: i("PDP_Size_Recommendation_Scale_Small") }),
              /* @__PURE__ */ e("span", { className: n.scaleLabel, children: i("PDP_Size_Recommendation_Scale_Perfect") }),
              /* @__PURE__ */ e("span", { className: n.scaleLabel, children: i("PDP_Size_Recommendation_Scale_Big") })
            ] })
          ] }),
          (o == null ? void 0 : o.value) && /* @__PURE__ */ e("span", { className: n.sizeText, children: o.value })
        ] });
    }
  )
), Pn = t.discriminatedUnion("template", [
  ft
]), vn = f(
  "SizeRecommendation",
  P(Pn, (a) => {
    if (a.template === "scale")
      return /* @__PURE__ */ e(fn, { ...a });
  })
), yn = t.object({
  variants: t.custom().optional(),
  template: t.enum(["button", "text"]).optional(),
  buttonVariants: za.shape.variants.optional()
}), Sn = f(
  "ProductBundleUpsell",
  P(
    {
      schema: yn,
      defaultProps: {
        template: "button",
        buttonVariants: {
          width: "full",
          color: "black",
          style: "outline"
        }
      }
    },
    ({ variants: a, buttonVariants: n, template: i }) => {
      const o = be("bundle")[0], s = _(), c = Xt.styles(a);
      return o ? /* @__PURE__ */ e(
        re,
        {
          productBase: o.product.base,
          className: c.base,
          children: i === "button" ? /* @__PURE__ */ e(
            Ee,
            {
              label: s("PDP_Bundle_Upsell_Title", {
                // Add support for discount when it exists.
                name: o.product.base.content.name
              }),
              variants: n
            }
          ) : /* @__PURE__ */ e("span", { children: s("PDP_Bundle_Upsell_Title", {
            name: o.product.base.content.name
          }) })
        }
      ) : null;
    }
  )
), Pt = t.object({
  heading: t.string().optional(),
  subtitle: t.string().optional(),
  image: Re.optional().nullable(),
  condition: t.string().optional(),
  variants: t.custom().optional()
}), wn = f(
  "ProductGiftWithPurchase",
  P(
    {
      schema: Pt,
      defaultProps: {
        image: {
          displaySize: "5vw"
        }
      }
    },
    ({ heading: a, subtitle: n, image: i, variants: o, condition: s }) => {
      var r;
      const c = ea.styles(o);
      return !a && !n && !i ? null : /* @__PURE__ */ u("div", { className: c.base, children: [
        /* @__PURE__ */ u("div", { className: c.contentWrapper, children: [
          i && ((r = i.image) == null ? void 0 : r.src) && /* @__PURE__ */ e(F, { ...i, className: c.image }),
          /* @__PURE__ */ u("div", { className: c.textWrapper, children: [
            a && /* @__PURE__ */ e("h3", { className: c.heading, children: a }),
            n && /* @__PURE__ */ e(Ra, { content: n, className: c.subtitle })
          ] })
        ] }),
        s && /* @__PURE__ */ e("span", { className: c.condition, children: s })
      ] });
    }
  )
), vt = t.object({
  template: t.literal("cairo"),
  variants: t.custom().optional(),
  content: t.custom()
}), kn = f(
  "SizeGuideContent",
  P(vt, ({ variants: a, content: n }) => {
    const i = ta.styles(a);
    return /* @__PURE__ */ e(ja.Provider, { value: !0, children: /* @__PURE__ */ e("div", { className: i.contentWrapper, children: n }) });
  })
), yt = t.object({
  template: t.literal("drawer"),
  contentSettings: vt.optional(),
  drawerSettings: t.custom().optional(),
  enabled: t.boolean().optional(),
  applyButtonSettings: ke.optional(),
  closeButtonSettings: ke.optional()
}), _n = "cairo", Nn = 1024, Tn = f(
  "SizeGuideDrawer",
  P(yt, (a) => {
    aa.styles(), _();
    const n = a.contentSettings || {
      template: _n
    };
    if (!a.enabled)
      return null;
    const [i, o] = G(!1);
    return x(() => {
      const s = () => {
        o(window.innerWidth > Nn);
      };
      return window.addEventListener("resize", s), s(), () => {
        window.removeEventListener("resize", s);
      };
    }, []), /* @__PURE__ */ e(
      D,
      {
        customOverlayId: "size-guide",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        hasHandle: !i,
        variants: {
          dragHandle: i ? "false" : "true",
          rounded: i ? "none" : "strong",
          background: "white",
          direction: i ? "right" : "bottom"
        },
        direction: i ? "right" : "bottom",
        ...a.drawerSettings,
        children: /* @__PURE__ */ e(D.Content, { children: /* @__PURE__ */ e(kn, { ...n }) })
      }
    );
  })
), ve = t.discriminatedUnion("template", [
  yt
]), Bn = f(
  "SizeGuide",
  P(ve, (a) => {
    switch (a.template) {
      case "drawer":
        return /* @__PURE__ */ e(Tn, { ...a });
      default:
        return null;
    }
  })
), ye = t.object({
  link: Da.optional(),
  label: t.string().optional(),
  icon: t.custom().optional(),
  variants: t.custom().optional()
}), Cn = f(
  "SizeGuideTrigger",
  P(ye, ({ variants: a, label: n, link: i, icon: o }) => {
    const s = ia.styles(a);
    return /* @__PURE__ */ e(
      Ia,
      {
        onClick: () => X.emit("open", { overlayId: "size-guide" }),
        className: s.trigger,
        label: n,
        icon: o,
        ...i
      }
    );
  })
), An = t.object({
  variants: t.custom().optional()
}), Dn = ({ variants: a }) => {
  const n = _(), i = na.styles(a), o = he(), s = o.discountFromPriceOfItemsOutsideBundle.formatted, c = o.discountFromPriceOfItemsOutsideBundle.number;
  return !s || c <= 0 ? null : /* @__PURE__ */ u("div", { className: i.base, children: [
    /* @__PURE__ */ e("h3", { className: i.heading, children: n("PDP_Bundle_Promo_Banner_Heading", {
      bundleSavings: s
    }) }),
    /* @__PURE__ */ e("p", { className: i.text, children: n("PDP_Bundle_Promo_Banner_Text") })
  ] });
}, In = f(
  "ProductBundlePromoBanner",
  P(
    {
      schema: An,
      defaultProps: {}
    },
    (a) => W() !== "bundle" ? null : /* @__PURE__ */ e(Dn, { ...a })
  )
), p = {
  SizeGuide: Bn,
  Details: pi,
  Root: Za,
  ImageGallery: ki,
  AddToCart: Ki,
  Specifications: Ni,
  Attributes: zi,
  SizePicker: Fi,
  Siblings: en,
  RelatedProducts: nn,
  StickyAddToCart: ln,
  Bundle: cn,
  BundleUpsell: Sn,
  UspBlock: gn,
  SizeGuideTrigger: Cn,
  SizeRecommendation: vn,
  GiftWithPurchase: wn,
  BundlePromoBanner: In,
  PriceHistoryDrawer: ni
  // Add other components as needed
}, St = t.object({
  template: t.literal("basic"),
  variants: t.custom().optional(),
  productTypeSettings: ae.optional(),
  productDesignerSettings: ae.optional(),
  relatedProductsSettings: Y.optional(),
  sizePickerSettings: ce.optional(),
  uspBlockSettings: ie.optional(),
  siblingsPickerSettings: de.optional(),
  sizeGuideSettings: ve.optional(),
  sizeGuideTriggerSettings: ye.optional(),
  belowTheFoldComponents: t.custom().optional()
}), zn = f(
  "ProductTemplateAsBasic",
  P(
    {
      schema: St,
      defaultProps: {
        template: "basic",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: n,
      uspBlockSettings: i,
      siblingsPickerSettings: o,
      sizeGuideSettings: s,
      sizeGuideTriggerSettings: c,
      belowTheFoldComponents: r
    }) => {
      var g;
      const l = C(), d = oa.styles(), m = _();
      return /* @__PURE__ */ e(ee, { mode: "wait", children: /* @__PURE__ */ u(
        U.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: l.productId,
          className: d.base,
          children: [
            /* @__PURE__ */ e(
              Z,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden ml-3 mb-3"
              }
            ),
            /* @__PURE__ */ e(p.ImageGallery, { template: "keen", indicator: "number" }),
            /* @__PURE__ */ e(p.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ u("section", { className: d.detailsWrapper, children: [
              /* @__PURE__ */ e(
                Z,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block mb-4"
                }
              ),
              /* @__PURE__ */ e(p.Details.Brand, {}),
              /* @__PURE__ */ e(p.Details.Name, {}),
              /* @__PURE__ */ e(p.Details.Price, {}),
              /* @__PURE__ */ e(p.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                p.Siblings,
                {
                  template: "image-card",
                  ...o
                }
              ),
              /* @__PURE__ */ e(p.SizeGuide, { template: "drawer", ...s }),
              /* @__PURE__ */ e(
                p.SizePicker,
                {
                  template: "button-grid",
                  ...n,
                  headerContent: /* @__PURE__ */ e(
                    p.SizeGuideTrigger,
                    {
                      ...c,
                      label: m("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(p.AddToCart, { template: "button" }),
              /* @__PURE__ */ e(p.UspBlock, { ...i }),
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  label: m("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: d.belowTheFoldDetails, children: [
              /* @__PURE__ */ e(
                p.Details.Description,
                {
                  label: m("PDP_Product_Description_Label")
                }
              ),
              /* @__PURE__ */ e(
                p.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0,
                        defaultValue: "details"
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        trigger: m("PDP_Product_Details"),
                        value: "details",
                        content: l.content.description
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Material"),
                        attributeKey: "material"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e("div", { className: d.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(g = a == null ? void 0 : a.swiperSettings) == null ? void 0 : g.settings,
                    headerSettings: {
                      heading: {
                        heading: m("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            r
          ]
        }
      ) });
    }
  )
), wt = t.object({
  template: t.literal("helsinki"),
  breadcrumbsSettings: Ka.optional(),
  imageGallerySettings: at.optional(),
  addToCartSettings: dt.optional(),
  descriptionSettings: Ae.optional(),
  specificationSettings: nt.optional(),
  progressBarSettings: Ie.optional(),
  tagsSettings: t.array(ze).optional(),
  relatedProductsSettings: Y.optional(),
  discontinuedBadgeWrapper: Me.optional(),
  shippingBarometer: Ma.optional(),
  id: t.string().optional()
}), Ln = f(
  "ProductPageTemplateHelsinki",
  P(
    {
      schema: wt,
      defaultProps: {
        template: "helsinki",
        breadcrumbsSettings: {
          variants: {
            isOn: "pdp"
          }
        },
        discontinuedBadgeWrapper: {
          rotate: "randomize"
          // variants: {
          //   color: "red",
          // },
        },
        imageGallerySettings: {
          template: "keen",
          indicator: "dots"
        },
        addToCartSettings: {
          template: "quantity-picker"
        },
        descriptionSettings: {
          readMoreSettings: {
            enabled: !0,
            limit: 160
          }
        },
        specificationSettings: {
          template: "table"
        },
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      breadcrumbsSettings: a,
      imageGallerySettings: n,
      addToCartSettings: i,
      descriptionSettings: o,
      specificationSettings: s,
      progressBarSettings: c,
      tagsSettings: r,
      relatedProductsSettings: l,
      discontinuedBadgeWrapper: d,
      shippingBarometer: m,
      id: g
    }) => {
      var y;
      const { status: v } = ge(), b = _(), h = sa.styles();
      return /* @__PURE__ */ u(
        "section",
        {
          id: g,
          className: "grid-cols-12 lg:grid-rows-[min-content_max-content] grid lg:gap-4 w-full lg:gap-y-12 bg-white lg:px-8 rounded-lg lg:max-h-[90vh] overflow-y-scroll",
          children: [
            /* @__PURE__ */ u(p.ImageGallery, { ...n, template: "keen", children: [
              /* @__PURE__ */ e(
                Z,
                {
                  ...a,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  }
                }
              ),
              v === "discontinued" && /* @__PURE__ */ e("div", { className: h.discountinuedBadgeWrapper, children: /* @__PURE__ */ e(
                Ce,
                {
                  label: b("PDP_Discontinued_Badge"),
                  ...d
                }
              ) })
            ] }),
            /* @__PURE__ */ u("div", { className: h.addToCartWrapper, children: [
              /* @__PURE__ */ e(p.Details.Name, {}),
              v === "out-of-stock" && /* @__PURE__ */ u("div", { className: h.outOfStock, children: [
                /* @__PURE__ */ e("span", { className: h.outOfStockIndicator }),
                /* @__PURE__ */ e("span", { children: b("PDP_Out_Of_Stock") })
              ] }),
              v === "discontinued" && /* @__PURE__ */ u("div", { className: h.discontinued, children: [
                /* @__PURE__ */ e("span", { className: h.discontinuedIndicator }),
                /* @__PURE__ */ e("span", { children: b("PDP_Discontinued_Message") })
              ] }),
              v !== "discontinued" && /* @__PURE__ */ e(
                p.AddToCart,
                {
                  ...i ?? { template: "quantity-picker" }
                }
              ),
              /* @__PURE__ */ e(
                Ha,
                {
                  ...m,
                  className: h.shippingBarometer
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: h.detailsWrapper, children: [
              /* @__PURE__ */ e(p.Details.ShortDescription, {}),
              /* @__PURE__ */ e(p.Details.Description, { ...o }),
              /* @__PURE__ */ e(
                p.Specifications,
                {
                  ...s ?? { template: "table" }
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: h.attributesWrapper, children: [
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  template: "progress-bar",
                  ...c
                }
              ),
              r && /* @__PURE__ */ e("div", { className: h.tags, children: r.map((w, S) => /* @__PURE__ */ e(p.Attributes, { ...w }, S)) })
            ] }),
            /* @__PURE__ */ e("div", { className: h.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(y = l == null ? void 0 : l.swiperSettings) == null ? void 0 : y.settings,
                    headerSettings: {
                      heading: {
                        heading: b("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      );
    }
  )
), kt = t.object({
  template: t.literal("malibu"),
  variants: t.custom().optional(),
  productTypeSettings: ae.optional(),
  relatedProductsSettings: Y.optional(),
  siblingSettings: Le.optional(),
  sizePickerSettings: ce.optional(),
  uspBlockSettings: ie.optional(),
  giftWithPurchaseSettings: Pt.optional(),
  extendAccordion: t.array(Je).optional(),
  sizeGuideSettings: ve.optional(),
  sizeGuideTriggerSettings: ye.optional(),
  priceSettings: Ye.optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  sizeFinderSlot: t.custom().optional(),
  sizeFinderSlotPosition: t.enum(["above-atc", "below-atc"]).optional(),
  openFirstAccordionItem: t.boolean().optional(),
  alwaysShowStickyAddToCart: t.boolean().optional(),
  tagsComponentSlot: t.custom().optional(),
  bundleUpsell: t.custom().optional(),
  accordionRootSettings: t.custom().optional(),
  bundleDisplayStyle: t.enum(["card", "text"]).optional()
}), xn = f(
  "ProductTemplateAsMalibu",
  P(
    {
      schema: kt,
      defaultProps: {
        template: "malibu",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              itemsInView: {
                initial: "2.1",
                lg: "4.2",
                xl: "5"
              },
              variants: {
                layout: "stacked",
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: n,
      siblingSettings: i,
      sizePickerSettings: o,
      uspBlockSettings: s,
      extendAccordion: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      giftWithPurchaseSettings: d,
      priceSettings: m,
      belowTheFoldComponents: g,
      reviewComponentSlot: v,
      accordionRootSettings: b,
      sizeFinderSlot: h,
      bundleUpsell: y,
      sizeFinderSlotPosition: w,
      tagsComponentSlot: S,
      openFirstAccordionItem: B,
      alwaysShowStickyAddToCart: A,
      bundleDisplayStyle: I
    }) => {
      var H;
      const T = C(), L = ra.styles(), K = _(), O = z("fit_text", t.string()), [Q, M] = G(
        void 0
      );
      return x(() => {
        const k = () => M("reviews");
        return window.addEventListener("pdp:open-reviews", k), () => window.removeEventListener("pdp:open-reviews", k);
      }, []), /* @__PURE__ */ u("section", { className: L.base, children: [
        /* @__PURE__ */ e($e, { template: "drawer" }),
        /* @__PURE__ */ e(p.ImageGallery, { template: "keen", indicator: "dots" }),
        /* @__PURE__ */ e(
          p.StickyAddToCart,
          {
            template: "button",
            mode: A ? "isNotVisible" : "isScrolledPast"
          }
        ),
        /* @__PURE__ */ e(p.ImageGallery, { template: "grid" }),
        /* @__PURE__ */ u("section", { className: L.detailsWrapper, children: [
          /* @__PURE__ */ e(
            Z,
            {
              enableWrapper: !1,
              variants: { isOn: "pdp" },
              layout: {
                spacing: { applySpacing: "false" },
                position: { applyPosition: "false" }
              }
            }
          ),
          /* @__PURE__ */ e(p.Details.Name, {}),
          /* @__PURE__ */ e(
            p.Details.Price,
            {
              ...m,
              priceHistoryDrawerSettings: {
                isEnabled: !0,
                trigger: /* @__PURE__ */ e(Ea, { className: "w-3 h-3 lg:w-4 lg:h-4 fill-[#71717a]" })
              }
            }
          ),
          /* @__PURE__ */ e(p.Details.ProductType, { ...n }),
          v,
          S,
          /* @__PURE__ */ e(p.Siblings, { template: "image-card", ...i }),
          /* @__PURE__ */ e(
            p.SizePicker,
            {
              template: "button-grid",
              ...o
            }
          ),
          /* @__PURE__ */ e(p.BundlePromoBanner, {}),
          /* @__PURE__ */ e(p.Bundle, {}),
          w !== "below-atc" && h && h,
          /* @__PURE__ */ e(
            p.AddToCart,
            {
              template: "button",
              isNotifyMeEnabled: (H = o == null ? void 0 : o.notifyMe) == null ? void 0 : H.enabled
            }
          ),
          w === "below-atc" && h && h,
          I === "text" && /* @__PURE__ */ e(p.BundleUpsell, {}),
          (O == null ? void 0 : O.value) && /* @__PURE__ */ e("span", { className: L.fitText, children: O.value }),
          /* @__PURE__ */ e(p.SizeRecommendation, { template: "scale" }),
          (r == null ? void 0 : r.enabled) && /* @__PURE__ */ e(
            p.SizeGuideTrigger,
            {
              ...l,
              label: K("Size_Guide_Trigger_Label")
            }
          ),
          /* @__PURE__ */ e(p.SizeGuide, { template: "drawer", ...r }),
          /* @__PURE__ */ e(p.UspBlock, { ...s }),
          /* @__PURE__ */ e(p.GiftWithPurchase, { ...d }),
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "icon-blocks",
              attributeKey: "productFeaturesVariant"
            }
          ),
          /* @__PURE__ */ e(
            p.Details.Accordion,
            {
              items: [
                {
                  content: {
                    trigger: K("PDP_Product_Description"),
                    value: "description",
                    forceMount: !0,
                    content: T.content.description
                  }
                },
                {
                  content: {
                    trigger: K("PDP_Fabric_Care"),
                    attributeKey: "fabricCare_text",
                    forceMount: !0
                  }
                },
                {
                  content: {
                    trigger: K("PDP_Product_Details"),
                    forceMount: !0,
                    content: T.content.shortDescription
                  }
                },
                ...c ?? []
              ],
              settings: {
                radixAccordionSettings: {
                  root: b ?? {
                    type: "single",
                    value: Q,
                    defaultValue: B ? "description" : void 0,
                    onValueChange: (k) => M(k)
                  }
                }
              }
            }
          ),
          I === "card" && y
        ] }),
        g
      ] });
    }
  )
), _t = t.object({
  template: t.literal("vienna"),
  variants: t.custom().optional(),
  relatedProductsSettings: Y.optional(),
  sizePickerSettings: se.optional(),
  sizePicker2Settings: se.optional(),
  uspBlockSettings: ie.optional(),
  imageGallerySettings: Pe.optional(),
  siblingsPickerSettings: de.optional(),
  reviewCarouselComponent: t.custom().optional(),
  reviewStarsComponent: t.custom().optional(),
  detailsComponentSlot: t.custom().optional(),
  sizeGuideComponentSlot: t.custom().optional(),
  beforeSiblingsSlot: t.custom().optional(),
  afterSiblingsSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  afterAddToCartSlot: t.custom().optional(),
  afterAttributesSlot: t.custom().optional()
}), Gn = () => /* @__PURE__ */ e(p.AddToCart, { template: "button" }), Wn = ({
  sizePickerSettings: a,
  sizePicker2Settings: n
}) => {
  const i = _(), o = ba();
  return /* @__PURE__ */ e(R, { children: o ? /* @__PURE__ */ u(R, { children: [
    /* @__PURE__ */ e(p.SizePicker, { ...a, template: "modal" }),
    /* @__PURE__ */ e(
      p.SizePicker,
      {
        ...n,
        template: "modal",
        triggerLabel: i("PDP_Add_To_Cart"),
        customOverlayId: "size-picker-modal-2"
      }
    )
  ] }) : /* @__PURE__ */ e(
    oe,
    {
      label: i("PDP_Out_Of_Stock"),
      disabled: !0,
      "aria-disabled": "true",
      variants: {
        width: "full"
      }
    }
  ) });
}, On = f(
  "ProductTemplateAsVienna",
  P(
    {
      schema: _t,
      defaultProps: {
        template: "vienna",
        sizePickerSettings: {
          template: "modal",
          buttonVariants: {
            color: "black",
            style: "outline",
            width: "full"
          }
        },
        sizePicker2Settings: {
          template: "modal",
          buttonVariants: {
            style: "solid",
            width: "full"
          }
        },
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: n,
      sizePicker2Settings: i,
      uspBlockSettings: o,
      imageGallerySettings: s,
      siblingsPickerSettings: c,
      reviewCarouselComponent: r,
      detailsComponentSlot: l,
      reviewStarsComponent: d,
      sizeGuideComponentSlot: m,
      beforeSiblingsSlot: g,
      afterSiblingsSlot: v,
      belowTheFoldComponents: b,
      afterAddToCartSlot: h,
      afterAttributesSlot: y
    }) => {
      var O, Q, M, H, k;
      const w = C(), S = la.styles(), B = _(), A = W(), I = (O = z(
        "product_highlight_text",
        t.string()
      )) == null ? void 0 : O.value, T = (Q = z(
        "pr_video_url",
        t.string()
      )) == null ? void 0 : Q.value, L = (M = z("pr_badge", t.string().array())) == null ? void 0 : M.value, K = A === "simple";
      return /* @__PURE__ */ u("section", { className: S.base, children: [
        /* @__PURE__ */ e("div", { className: S.breadcrumbsWrapper, children: /* @__PURE__ */ e(
          Z,
          {
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            }
          }
        ) }),
        /* @__PURE__ */ e(
          p.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            buttonInSlider: {
              enabled: !!(T && (T == null ? void 0 : T.length) > 0),
              onClick: () => {
                const N = document == null ? void 0 : document.getElementById("youtube-video");
                N && N.scrollIntoView({ behavior: "smooth" });
              },
              label: B("Product_Video_Button_Text")
            },
            ...s,
            children: /* @__PURE__ */ e("div", { className: S.badgesWrapper, children: L == null ? void 0 : L.map((N, E) => /* @__PURE__ */ e(Ce, { label: N }, E)) })
          }
        ),
        /* @__PURE__ */ u("section", { className: S.detailsWrapper, children: [
          /* @__PURE__ */ u("div", { className: "flex flex-row justify-between items-center lg:mt-0 mb-2", children: [
            /* @__PURE__ */ u("div", { className: "flex items-center empty:hidden flex-wrap", children: [
              /* @__PURE__ */ e(p.Details.ProductType, { attributeKey: "wiring" }),
              ((H = z("wiring", t.string())) == null ? void 0 : H.value) && ((k = z("padding", t.string())) == null ? void 0 : k.value) && /* @__PURE__ */ e("span", { className: "m-1 mb-2", children: "•" }),
              /* @__PURE__ */ e(p.Details.ProductType, { attributeKey: "padding" })
            ] }),
            d
          ] }),
          /* @__PURE__ */ e(p.Details.Name, {}),
          /* @__PURE__ */ e(p.Details.Price, {}),
          g,
          /* @__PURE__ */ e(
            p.Siblings,
            {
              template: "color-swatch",
              ...c
            }
          ),
          v,
          /* @__PURE__ */ u("div", { className: "flex flex-col gap-2", children: [
            m,
            /* @__PURE__ */ e(
              "div",
              {
                className: "w-full flex flex-row gap-4",
                id: "add-to-cart-component",
                children: K ? /* @__PURE__ */ e(Gn, {}) : /* @__PURE__ */ e(
                  Wn,
                  {
                    sizePicker2Settings: i,
                    sizePickerSettings: n
                  }
                )
              }
            ),
            h
          ] }),
          /* @__PURE__ */ e(p.UspBlock, { ...o }),
          /* @__PURE__ */ e(
            p.StickyAddToCart,
            {
              template: "button",
              mode: "isNotVisible",
              selectSizeAction: "open-size-picker",
              withSizePicker: !0
            }
          )
        ] }),
        /* @__PURE__ */ e(p.Details.Description, {}),
        I && /* @__PURE__ */ e("ul", { className: S.highlightTextWrapper, children: I == null ? void 0 : I.split(";").map((N, E) => /* @__PURE__ */ e("li", { className: S.highlightTextRow, children: N }, E)) }),
        /* @__PURE__ */ u("section", { className: S.attributesWrapper, children: [
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "row",
              attributeKey: "material_pdp_text"
            }
          ),
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "row",
              attributeKey: "washing_advice_text"
            }
          ),
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "row",
              attributeKey: "product_key",
              data: {
                attributeLabel: B("Article_Number"),
                value: w.productKey
              }
            }
          )
        ] }),
        y,
        T && /* @__PURE__ */ e("div", { className: S.productVideo, id: "youtube-video", children: /* @__PURE__ */ e(
          "div",
          {
            className: "relative w-full",
            style: { paddingBottom: "56.25%" },
            children: /* @__PURE__ */ e(
              "iframe",
              {
                className: "absolute top-0 left-0 w-full h-full",
                src: T.includes("youtube.com/watch?v=") ? `https://www.youtube.com/embed/${T.split("v=")[1]}` : T,
                title: "Product video",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          p.RelatedProducts,
          {
            template: "image-cards",
            relationType: "standard",
            ...a
          }
        ),
        l,
        b
      ] });
    }
  )
), Nt = t.object({
  template: t.literal("graz"),
  variants: t.custom().optional(),
  productTypeSettings: ae.optional(),
  productDesignerSettings: ae.extend({
    link: t.string().optional()
  }).optional(),
  relatedProductsSettings: Y.optional(),
  sizePickerSettings: ce.optional(),
  uspBlockSettings: ie.optional(),
  siblingsPickerSettings: de.optional(),
  sizeGuideSettings: ve.optional(),
  sizeGuideTriggerSettings: ye.optional(),
  productSku: t.string().optional(),
  ecomidNudgeSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional()
}), Rn = f(
  "ProductTemplateAsGraz",
  P(
    {
      schema: Nt,
      defaultProps: {
        template: "graz",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: n,
      productDesignerSettings: i,
      sizePickerSettings: o,
      uspBlockSettings: s,
      siblingsPickerSettings: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      ecomidNudgeSlot: d,
      belowTheFoldComponents: m,
      productSku: g
    }) => {
      var w, S, B;
      const v = C(), b = ca.styles(), h = _(), y = Va();
      return /* @__PURE__ */ e(ee, { mode: "wait", children: /* @__PURE__ */ u(
        U.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: v.productId,
          className: b.base,
          children: [
            /* @__PURE__ */ e($e, { template: "drawer" }),
            /* @__PURE__ */ e(
              Z,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden"
              }
            ),
            /* @__PURE__ */ e(p.ImageGallery, { template: "keen", indicator: "dots" }),
            /* @__PURE__ */ e(p.StickyAddToCart, { template: "button" }),
            /* @__PURE__ */ e(p.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ u("section", { className: b.detailsWrapper, children: [
              /* @__PURE__ */ e(
                Z,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block"
                }
              ),
              /* @__PURE__ */ u("div", { className: b.tagsWrapper, children: [
                /* @__PURE__ */ e(p.Details.ProductType, { ...n }),
                /* @__PURE__ */ e(y, { href: (i == null ? void 0 : i.link) ?? "", children: /* @__PURE__ */ e(p.Details.ProductType, { ...i }) })
              ] }),
              /* @__PURE__ */ e(p.Details.Name, {}),
              /* @__PURE__ */ e(p.Details.Price, {}),
              /* @__PURE__ */ e(p.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                p.Siblings,
                {
                  template: "color-swatch",
                  ...c
                }
              ),
              /* @__PURE__ */ e(p.SizeGuide, { template: "drawer", ...r }),
              /* @__PURE__ */ e(
                p.SizePicker,
                {
                  template: "button-grid",
                  ...o,
                  headerContent: /* @__PURE__ */ e(
                    p.SizeGuideTrigger,
                    {
                      ...l,
                      label: h("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(
                p.AddToCart,
                {
                  template: "button",
                  isNotifyMeEnabled: (w = o == null ? void 0 : o.notifyMe) == null ? void 0 : w.enabled
                }
              ),
              /* @__PURE__ */ e(p.UspBlock, { ...s }),
              /* @__PURE__ */ e("div", { className: b.retracedIcons, children: /* @__PURE__ */ e("retraced-icons", {}) }),
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  label: h("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              ),
              /* @__PURE__ */ e(
                p.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Product_Details"),
                        content: v.content.description
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Product_Material"),
                        attributeKey: "pr_fabric"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: h("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              ),
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  label: h("PDP_Product_Certifications"),
                  template: "icon-blocks",
                  attributeKey: "certifications"
                }
              ),
              d,
              /* @__PURE__ */ e("span", { className: b.productId, children: h("PDP_Product_Id", {
                productId: v.productId,
                sku: g || ""
              }) })
            ] }),
            /* @__PURE__ */ e("div", { className: b.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(S = a == null ? void 0 : a.swiperSettings) == null ? void 0 : S.settings,
                    headerSettings: {
                      heading: {
                        heading: h("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            m,
            /* @__PURE__ */ e("div", { className: b.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(B = a == null ? void 0 : a.swiperSettings) == null ? void 0 : B.settings,
                    headerSettings: {
                      heading: {
                        heading: h("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      ) });
    }
  )
), Tt = t.object({
  template: t.literal("salzburg"),
  variants: t.custom().optional(),
  relatedProductsSettings: Y.optional(),
  sizePickerSettings: se.optional(),
  uspBlockSettings: ie.optional(),
  siblingsPickerSettings: de.optional(),
  imageGallerySettings: Pe.optional(),
  descriptionSettings: Ae.optional(),
  nameSettings: qe.optional(),
  customSiblings: t.custom().optional()
}), jn = f(
  "ProductTemplateAsSalzburg",
  P(
    {
      schema: Tt,
      defaultProps: {
        template: "salzburg",
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      sizePickerSettings: a,
      imageGallerySettings: n,
      nameSettings: i,
      descriptionSettings: o,
      siblingsPickerSettings: s,
      variants: c,
      customSiblings: r
    }) => {
      const l = ne.main.styles(c), d = _();
      return /* @__PURE__ */ u("section", { className: l.base, children: [
        /* @__PURE__ */ u("section", { className: l.detailsWrapper, children: [
          /* @__PURE__ */ e(
            p.Details.Name,
            {
              ...i,
              blueprint: ne.details
            }
          ),
          /* @__PURE__ */ e(
            p.Details.Description,
            {
              ...o,
              blueprint: ne.details
            }
          ),
          r || /* @__PURE__ */ e(
            p.Siblings,
            {
              template: "color-swatch",
              ...s
            }
          ),
          /* @__PURE__ */ u("div", { className: "w-full flex flex-col lg:flex-row gap-3 lg:gap-4 justify-between", children: [
            /* @__PURE__ */ e(
              p.Details.Price,
              {
                blueprint: ne.details
              }
            ),
            /* @__PURE__ */ e(
              p.SizePicker,
              {
                template: "modal",
                ...a,
                triggerLabel: "PDP_Add_To_Cart"
              }
            )
          ] }),
          /* @__PURE__ */ e("span", { className: l.returnPolicyWrapper, children: d("Product_Return_Policy") })
        ] }),
        /* @__PURE__ */ e(
          p.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            blueprint: ne.gallery,
            ...n
          }
        )
      ] });
    }
  )
), Bt = t.object({
  template: t.literal("linz"),
  variants: t.custom().optional()
}), Kn = f(
  "ProductTemplateAsLinz",
  P(Bt, () => /* @__PURE__ */ u(p.Root, { template: "grid", children: [
    /* @__PURE__ */ e(
      p.ImageGallery,
      {
        template: "keen",
        indicator: "number",
        slidesPerView: { mobile: 1, tablet: 1, desktop: 3 },
        gap: { mobile: 0, tablet: 0, desktop: 0 }
      }
    ),
    /* @__PURE__ */ u("div", { className: "col-span-12 lg:col-start-9 lg:col-end-13 top-0 left-0 row-start-1 row-end-2 flex flex-col p-4 bg-[#aeaeae7d] backdrop-blur-lg rounded-lg sticky right-6 place-self-end w-full order-2 h-fit lg:self-end lg:p-6", children: [
      /* @__PURE__ */ e(p.Details.Name, {}),
      /* @__PURE__ */ e(p.Details.Price, {}),
      /* @__PURE__ */ e(p.Siblings, { template: "image-card" }),
      /* @__PURE__ */ e(p.SizePicker, { template: "button-grid" }),
      /* @__PURE__ */ e(p.AddToCart, { template: "button" })
    ] })
  ] }))
), Mn = t.discriminatedUnion("template", [
  St,
  wt,
  kt,
  _t,
  Nt,
  Tt,
  Bt
]), Co = f(
  "ProductTemplate",
  P(Mn, (a) => a.template === "basic" ? /* @__PURE__ */ e(zn, { ...a }) : a.template === "helsinki" ? /* @__PURE__ */ e(Ln, { ...a }) : a.template === "malibu" ? /* @__PURE__ */ e(xn, { ...a }) : a.template === "vienna" ? /* @__PURE__ */ e(On, { ...a }) : a.template === "graz" ? /* @__PURE__ */ e(Rn, { ...a }) : a.template === "salzburg" ? /* @__PURE__ */ e(jn, { ...a }) : a.template === "linz" ? /* @__PURE__ */ e(Kn, { ...a }) : null)
), Ao = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ e(
      "path",
      {
        stroke: "#18181B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.5999 4-7.7 7.7-3.5-3.5"
      }
    )
  }
);
export {
  ui as Accordion,
  Ki as AddToCart,
  ji as AddToCartButton,
  Wi as AddToCartQuanityPickerRow,
  Oi as AddToCartQuantityPicker,
  zi as Attributes,
  Ai as AttributesAsIconBlocks,
  Bi as AttributesAsProgressBar,
  Di as AttributesAsRow,
  Ci as AttributesAsTags,
  Ii as AttributesPropsSchema,
  Bo as AttributesTagsItemSchema,
  zn as Basic,
  ai as Brand,
  ti as BrandSchema,
  cn as Bundle,
  In as BundlePromoBanner,
  Xe as BundleSavingsBadge,
  Sn as BundleUpsell,
  Ao as Checkmark,
  Ua as CrossSvg,
  ei as Description,
  pi as Details,
  wn as GiftWithPurchase,
  Rn as Graz,
  Ln as Helsinki,
  Li as IconMinus,
  xi as IconPlus,
  ki as ImageGallery,
  Si as ImageGalleryAsGrid,
  vi as ImageGalleryAsKeen,
  Kn as Linz,
  xn as Malibu,
  Ya as Name,
  oi as Price,
  ni as PriceHistoryDrawer,
  Ye as PriceSchema,
  p as Product,
  Co as ProductTemplate,
  Mn as ProductTemplatePropsSchema,
  ci as ProductType,
  nn as RelatedProducts,
  ht as RelatedProductsImageCards,
  an as RelatedProductsSwiper,
  Za as Root,
  Fa as RootAsDrawer,
  $a as RootAsDrawerDialog,
  Fe as RootAsDrawerSchema,
  Qa as RootAsGrid,
  Qe as RootAsGridSchema,
  qa as RootPropsSchema,
  De as SHOP_THE_LOOK_ATTRIBUTE_KEY,
  lt as STATUS_TRANSLATIONS,
  jn as Salzburg,
  et as ShopTheLook,
  gi as ShopTheLookItem,
  Xa as ShortDescription,
  Ja as ShortDescriptionSchema,
  Xi as SiblingColorSwatchList,
  en as Siblings,
  Qi as SiblingsImageCard,
  Bn as SizeGuide,
  kn as SizeGuideContent,
  Tn as SizeGuideDrawer,
  Cn as SizeGuideTrigger,
  Fi as SizePicker,
  Mi as SizePickerButtonGrid,
  Ui as SizePickerModal,
  vn as SizeRecommendation,
  fn as SizeRecommendationScale,
  Ni as Specifications,
  _i as SpecificationsAsTable,
  it as SpecificationsAsTableSchema,
  ln as StickyAddToCart,
  sn as StickyAddToCartButton,
  ut as Swatch,
  gn as UspBlock,
  On as Vienna,
  li as Wrapper,
  ri as WrapperSchema,
  Je as accordionItemSchema,
  di as accordionSchema,
  ct as addToCartButtonSchema,
  rt as addToCartQuantityPickerSchema,
  dt as addToCartSchema,
  ot as attributesAsIconBlocksSchema,
  Ie as attributesAsProgressBarSchema,
  st as attributesAsRowSchema,
  ze as attributesAsTagsSchema,
  Ti as attributesProgressBarItemSchema,
  mi as bundleSavingsBadgeSchema,
  Ae as descriptionSchema,
  Pt as giftWithPurchaseSchema,
  tt as imageGalleryAsGridSchema,
  Pe as imageGalleryAsKeenSchema,
  at as imageGalleryPropsSchema,
  qe as nameSchema,
  Ze as priceHistoryDrawerSchema,
  ft as productSizeRecommendationScaleSchema,
  St as productTemplateAsBasicSchema,
  Nt as productTemplateAsGrazSchema,
  wt as productTemplateAsHelsinkiSchema,
  Bt as productTemplateAsLinzSchema,
  kt as productTemplateAsMalibuSchema,
  Tt as productTemplateAsSalzburgSchema,
  _t as productTemplateAsViennaSchema,
  ae as productTypeSchema,
  mt as relatedProductsImageCardsSchema,
  Y as relatedProductsSchema,
  bt as relatedProductsSwiperSchema,
  bi as shopTheLookItemSchema,
  fi as shopTheLookSchema,
  pt as siblingColorSwatchListSchema,
  Le as siblingsImageCardSchema,
  de as siblingsSchema,
  vt as sizeGuideContentSchema,
  yt as sizeGuideDrawerSchema,
  ve as sizeGuideSchema,
  ye as sizeGuideTriggerSchema,
  ce as sizePickerButtonGridSchema,
  se as sizePickerModalSchema,
  $i as sizePickerSchema,
  Pn as sizeRecommendationSchema,
  nt as specificationsPropsSchema,
  gt as stickyAddToCartButtonSchema,
  rn as stickyaddToCartSchema,
  Ri as useAddToCartLabel,
  on as useElementVisibility,
  ie as uspBlockSchema
};
//# sourceMappingURL=index.es.js.map
